import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild
} from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from "@angular/forms";
import { ActivatedRoute, NavigationExtras, Router } from "@angular/router";
import { DecimalPipe } from "@angular/common";
import { shareReplay, Subject, Subscription, takeUntil } from "rxjs";

// Angular material imports
import { MatStepper } from "@angular/material/stepper";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { MatDialog } from "@angular/material/dialog";

// Services imports
import { MotorDataDataService } from "src/app/share/data-service/motor.data.service";
import { MotorBundleService } from "../../data-service/motor-bundle.service";
import { AlertService } from "src/app/share/service/alert.service";
import { LoadingOverlayService } from "src/app/share/service/loading-overlay.service";
import { FooterMarginService } from "src/app/share/service/footer-margin.service";
import { ValidatorFunction } from "src/app/share/function/validator.function";
import { ScreenSizeService } from "src/app/share/service/screen-size.service";
import { CommonFunction } from "src/app/share/function/common.function";
import { SignalrService } from "src/app/services/signalr.service";
import { HttpClient } from "@angular/common/http";

// Other packages imports
import * as moment from "moment";
import { TranslateService } from "@ngx-translate/core";
import { NgxSpinnerService } from "ngx-spinner";
import { GoogleTagManagerService } from "angular-google-tag-manager";

// Interfaces imports
import {
  BNPLRateListInterface,
  D2CQuotationInterface,
  EPPChargeInterface,
  ExcessInterface,
  MembershipAddonInterface,
  MembershipBenefitInterface,
  MembershipDiscountInterface,
  OtherInsurerInterface,
  ProductAddOnInterface,
  ProductDocumentInterface,
  PromoCodeInterface,
  SelectedExcessInterface,
  MotorAddOnCARTPriceInterface,
  GeneraliGetOrderInfoInterface,
  ReferralCodeInterface,
  MotorRequestInterface
} from "src/app/share/interface/motor.interface";
import {
  ID_TYPE,
  MARITAL_STATUS,
  GENDER_TYPE
} from "src/app/share/constants/common.types";

// Static data imports
import {
  floodExpandedData,
  femaleExpandedData,
  familyExpandedData
} from "../../static/expanded-data";
import { RELATIONSHIP_LIST, STATE_LIST } from "../../static/general-data";
import {
  PAYMENT_OPTION_RAZER,
  PAYMENT_OPTION_SHOPBACK,
  PAYMENT_OPTION_EPP,
  PAYMENT_OPTION_VISA,
  PAYMENT_OPTION_EWALLET,
  PAYMENT_OPTION_FPX,
  PAYMENT_OPTION_FP,
  PAYMENT_OPTION_ATOME,
  PAYMENT_OPTION_BNPL,
  PAYMENT_OPTION_FPX_ENTERPRISE
} from "src/app/share/constants/payment-options";
import { HIGHER_EXCESS } from "src/app/share/constants/excess.types";
import { INSURER_FULL_NAME } from "src/app/share/constants/common.info";
import { CAMPAIGN_TYPE } from "src/app/share/constants/campaign";

// Component imports
import { EditQuotationComponent } from "src/app/dashboard/edit-quotation/edit-quotation.component";
import { SubmitSuccessDialogComponent } from "src/app/dashboard/submit-success-dialog/submit-success-dialog.component";
import { BenefitDialogComponent } from "src/app/dashboard/benefit-dialog/benefit-dialog.component";
import { CarVariantDialogComponent } from "src/app/share/component/car-variant-dialog/car-variant-dialog.component";
import { MotorQuotationDataService, SubmitCustomerInfoRequest } from "src/app/share/data-service/motor/motor-quotation.data.service";
import { TimerService } from "src/app/share/service/timer.service";
import { MotorQuotationInterface } from "src/app/share/interface/motor-quotation.interface";
import {
  FULLY_REDEEMED_MSG,
  HAS_ENDED_MSG
} from "src/app/share/constants/campaign";
import { FieldData } from "src/app/share/interface/common.interface";
import { ConfirmDriveplusDialogComponent } from "src/app/share/component/confirm-driveplus-dialog/confirm-driveplus-dialog.component";
import { FileFunction } from "src/app/share/function/file.function";
import { AcknowledgementComponent } from "../../ui/acknowledgement/acknowledgement.component";
import { CleverTapService } from "src/app/share/service/clevertap.service";
import { NewUserGamificationComponent } from "../../ui/new-user-gamification/new-user-gamification.component";

@Component({
  selector: "app-plans",
  templateUrl: "./plans.component.html",
  styleUrls: ["./plans.component.scss"],
  providers: [DecimalPipe]
})
export class PlansComponent implements OnInit, OnDestroy {
  id: string;
  quotationId: string;
  lang: string;
  seat: number;
  selectedBundle: any[] = [];
  selectedBundleAddOn: any[] = [];
  selectedMotorMembership: any[] = [];
  defaultMotorMembership: any[] = [];
  selectedMotorMembershipLockDeal: any[] = [];
  selectedAddOn: any[] = [];
  selectedAddOnToDisplay: any[] = [];
  selectedPsxtraAddOnToDisplay: any[] = [];
  selectedNonSSTAddOnToDisplay: any[] = [];
  selectedPayment: string = PAYMENT_OPTION_RAZER;
  selectedFullPriceMethod: string = PAYMENT_OPTION_VISA;
  originalSelectedAddon: any[] = [];

  /* Membership Benefits */
  membershipRTHandlingFee: number;
  membershipEppRate: number;
  membershipAtomeDiscount: number;
  membershipEppDiscount: number;

  // Insurer Flags
  isTakaful: boolean = false;
  isAllianzQuotation: boolean = false;
  isZurichQuotation: boolean = false;

  // Insurance placeholder
  additionalInsurerList = [];
  selectedAdditionalInsurer = [];
  otherInsurerList: OtherInsurerInterface[] = [];
  selectedOtherInsurers: string[] = [];

  enableDeliveryAddress: boolean = false;
  isRoadtaxSelected: boolean = true;
  quotationIsExpired: boolean = true;

  isEHailing: boolean = false;
  isFloodChecked: boolean;
  isDriverChecked: boolean;
  showRoadTaxList: boolean = false;
  isIncludeDigitalRoadtax: boolean = true;
  isLoadingBundleData: boolean = false;

  driverAddOnCount: number = 0;
  maxAdditionalDriver: number = 5;
  maxFreeDriver: number = 5;
  productDocumentInterface: ProductDocumentInterface[] = [];
  includedAddOn = [];
  consolidatedAddOn = [];
  popularConsolidatedAddOn = [];
  driversAddOn = [];
  addOnListToDisplay = [];
  hasRoadtaxAddon = false;
  motorMembershipList: MembershipAddonInterface[] = [];
  motorMembershipBenefitsDisplay: MembershipBenefitInterface[] = [];
  motorMembershipBenefits: MembershipBenefitInterface[] = [];
  motorMembershipLockDeal: MembershipAddonInterface[] = [];
  motorMembershipBenefitsLockDealDisplay: MembershipBenefitInterface[] = [];
  motorMembershipBenefitsLockDeal: MembershipBenefitInterface[] = [];
  motorMembershipRenewalDiscount: MembershipDiscountInterface[] = [];
  numberOfLltpSeats: number = 0;
  cartAddOnPriceList: MotorAddOnCARTPriceInterface[] = [];
  selectedCartDays: string;
  selectedCartDailyCoverage: string;
  minGCKTCoverage: number = 0;
  minVACoverage: number = 0;

  drivePlusLiteAddon: any;
  drivePlusStandardAddon: any;
  drivePlusPremiumAddon: any;
  defaultSelectedDPAddon: any;
  selectedDrivePlusPackageMembership: any;
  drivePlusTierChecked: boolean = true;

  // Static data
  floodBenefitsSnippets: any = floodExpandedData;
  femaleBenefitsSnippets: any = femaleExpandedData;
  familyBenefitsSnippets: any = familyExpandedData;
  stateList: any = STATE_LIST;
  relationshipList: any = RELATIONSHIP_LIST;
  personalDetailsCardData: any;
  availableSalesCampaign: any;

  paymentOptionRazer: string = PAYMENT_OPTION_RAZER;
  paymentOptionShopback: string = PAYMENT_OPTION_SHOPBACK;
  paymentOptionEPP: string = PAYMENT_OPTION_EPP;
  paymentOptionAtome: string = PAYMENT_OPTION_ATOME;
  paymentOptionBNPL: string = PAYMENT_OPTION_BNPL;

  paymentOptionVisa: string = PAYMENT_OPTION_VISA;
  paymentOptionEwallet: string = PAYMENT_OPTION_EWALLET;
  paymentOptionFpx: string = PAYMENT_OPTION_FPX;
  paymentOptionFpxEnterprise: string = PAYMENT_OPTION_FPX_ENTERPRISE;
  paymentOptionFullPrice: string = PAYMENT_OPTION_FP;

  idTypeOption = ID_TYPE;
  maritalStatusOption = MARITAL_STATUS;
  genderOption = GENDER_TYPE;
  campaignType = CAMPAIGN_TYPE;
  campaignWithoutPromoCode = [CAMPAIGN_TYPE.roadtaxOct10];

  idTypeList: FieldData[] = [
    { codeValue: "IC_NO", codeDesc: "IC Number" },
    { codeValue: "PASSPORT", codeDesc: "Passport" },
    { codeValue: "POLICE/ARMY", codeDesc: "Police/Army" }
  ];

  cartDayList: FieldData[] = [
    { codeValue: "7", codeDesc: "7" },
    { codeValue: "14", codeDesc: "14" },
    { codeValue: "21", codeDesc: "21" }
  ];

  cartDailyCoverageList: FieldData[] = [
    { codeValue: "50", codeDesc: "RM 50" },
    { codeValue: "100", codeDesc: "RM 100" },
    { codeValue: "200", codeDesc: "RM 200" }
  ];

  // vehicle photo upload
  showUploadMenu: boolean = false;
  uploadVehiclePhoto: any[] = [
    {
      name: "plans.step3Content.frontView",
      selectedFile: (File = null),
      type: "FrontCar"
    },
    {
      name: "plans.step3Content.rearView",
      selectedFile: (File = null),
      type: "BackCar"
    },
    {
      name: "plans.step3Content.leftSideView",
      selectedFile: (File = null),
      type: "LeftCar"
    },
    {
      name: "plans.step3Content.rightSideView",
      selectedFile: (File = null),
      type: "RightCar"
    }
  ];
  vehiclePhotoValidation: any = {
    fileExtension: "image/jpg, image/jpeg, image/png, application/pdf",
    fileExtensionToDisplay: "JPG, PNG, PDF",
    fileSize: 5
  };

  // Form group
  agreementFrmGroup: FormGroup;
  quotationFormGroup: FormGroup;
  infoFormGroup: FormGroup;
  addOnFormGroup: FormGroup;
  paymentFormGroup: FormGroup;

  promoCode: string;
  promo: PromoCodeInterface;
  promoGamification: PromoCodeInterface;
  promoError: string;
  promoMinAmount: number;
  promoMaxAmount: number;

  referralCode: string;
  referral: ReferralCodeInterface;
  referralError: string;

  // Data
  data: any;
  personalInfo: any;
  selectedQuotation: any;
  quotationList: D2CQuotationInterface[];
  quotationExpiredData: any;
  idType: string;
  ref: string;
  excessData: ExcessInterface[];
  selectedExcess: SelectedExcessInterface;
  isGeneraliIQ: boolean = false;
  isTMIMIQ: boolean = false;
  isZurichIQ: boolean = false;

  // Payment related
  eppChargeList: EPPChargeInterface[] = [];
  bnplRateList: BNPLRateListInterface[] = [];
  bankInstallmentCharge: { 3: number; 6: number; 12: number };

  subsVar: Subscription;
  paymentTypeChangeSub: Subscription;
  paymentChannelSub: Subscription;
  private timerSubscription: Subscription | null = null;
  private timerUnsubscribe$ = new Subject<void>();

  isDirectMarketing: boolean = false;
  isShowGeneraliPaymentConfirmation = false;

  ctaBanner = [];

  @ViewChild("stepper") stepper: MatStepper;

  maxDob: Date = new Date();

  /* Sales Campaign */
  roadTaxPromoPrice: number;

  constructor(
    private ngxSpinnerService: NgxSpinnerService,
    private motorDataDataService: MotorDataDataService,
    private motorQuotationService: MotorQuotationDataService,
    private timerService: TimerService,
    private motorBundleService: MotorBundleService,
    private formBuilder: FormBuilder,
    public translate: TranslateService,
    public screenSizeService: ScreenSizeService,
    private activatedRoute: ActivatedRoute,
    private alertService: AlertService,
    private router: Router,
    private dialog: MatDialog,
    private _decimalPipe: DecimalPipe,
    private loadingService: LoadingOverlayService,
    private footerMarginService: FooterMarginService,
    private gtmService: GoogleTagManagerService,
    public signalRService: SignalrService,
    private cd: ChangeDetectorRef,
    private http: HttpClient,
    private cleverTapService: CleverTapService,
    private motorQuotationDataService: MotorQuotationDataService,
  ) {
    this.signalRService.startConnection().subscribe((isConnected) => {
      this.signalRService.joinUserGroup(
        this.activatedRoute.snapshot.params.id.toString()
      );
      this.signalRService.registerUserGroupMessageListener();
      this.signalRService.registerGroupJoinedListener();
      this.updateQuotationMethod(isConnected);
    });
  }

  // -- Get new quotation method section

  public async updateQuotationMethod(isConnected) {
    // Get new updated quotation main method using signalr
    // If connection fail, only call the fallback method (refresh page every 5mins)
    if (isConnected) {
      this.signalRService.receiveUpdatedQuotation().subscribe((message) => {
        this.updateQuotationPrice(message);
        this.getPersonalInfo();
      });
    } else {
      await this.checkIfQuotationExpired();
    }
  }

  updateQuotationPrice(insurerName) {
    let quotation;
    this.motorDataDataService.getQuotationById(this.id).subscribe((x) => {
      quotation = x;
      this.quotationList = quotation;
      this.cd.detectChanges();
      var currentDateTime: Date = new Date();
      console.log(
        "[" + currentDateTime + "]" + insurerName + " display should be updated"
      );

      // Stop signalr connection if all quotations are updated
      if (this.isAllQuotationUpdated()) {
        this.signalRService.stopConnection();
      }
    });
  }

  isAllQuotationUpdated(): boolean {
    if (
      this.quotationList.filter(
        (x) => x.status == "New" || x.status == "On-Hold"
      ).length == 0
    )
      return true;
    else return false;
  }

  // -- End get new quotation method section

  get isPolicystreetProduct() {
    return (
      this.selectedQuotation && this.selectedQuotation.code == "PolicyStreet"
    );
  }

  get isInsurerWithoutServiceFee(): boolean {
    return ["AXA", "TMIM", "Zurich", "Zurich_Takaful"].includes(
      this.selectedQuotation?.code
    );
  }

  get eppDuration() {
    if (this.getFinalTotalBeforeCharges() >= 1200) return 12;
    if (this.getFinalTotalBeforeCharges() >= 1000) return 6;
    return 0;
  }

  get hideStepperLabel() {
    return this.stepper?.selectedIndex === 0 ? "hide-stepper" : "";
  }

  get inCollabImageSrc(): string {
    if (this.isPolicystreetProduct) {
      return "https://storage.googleapis.com/dev-ps-asset/Car_Insurance/ps-logo.png";
    } else {
      return this.selectedQuotation?.image || "";
    }
  }

  get updateOriginalRoadtaxPrice(): number {
    if (this.roadTaxPromoPrice) {
      let roadtaxHandlingFee = !this.showRoadTaxList
        ? 0
        : this.isIncludeDigitalRoadtax
        ? 0
        : 15;
      return this.roadTaxPromoPrice - roadtaxHandlingFee;
    } else {
      return this.personalInfo?.originalRoadTaxPrice;
    }
  }

  get memberRenewalDiscountPrice(): number {
    const driveplusRenewalDisc = this.motorMembershipRenewalDiscount;
    if (driveplusRenewalDisc) {
      return driveplusRenewalDisc["membershipDiscountPrice"];
    } else {
      return 0;
    }
  }

  get memberRenewalDiscountRefId(): any {
    const driveplusRenewalDisc = this.motorMembershipRenewalDiscount;
    if (driveplusRenewalDisc) {
      return driveplusRenewalDisc["membershipDiscountRefId"];
    } else {
      return null;
    }
  }

  get roadTaxDiscountMembership(): any {
    return this.selectedDrivePlusPackageMembership.find(
      (item) => item.code === "RoadTaxDiscount"
    );
  }

  get tierBenefitsWithoutRoadtax() {
    const order = [
      "FreeRoadTaxHandlingFee",
      "EPPDiscount",
      "NextRenewalDiscount",
      "ClaimSubmissionGuidance",
      "PrioritisedAssistance"
    ];

    return this.selectedDrivePlusPackageMembership
      .filter(
        (item) =>
          item.code !== "RoadTaxDiscount" && item.code !== "AtomeDiscount"
      )
      .sort((a, b) => order.indexOf(a.code) - order.indexOf(b.code));
  }

  get selectedMotorMembershipString(): string {
    return this.selectedMotorMembership?.[0]?.code || "";
  }
  async ngOnInit(): Promise<void> {
    // Listen for window resize events
    this.screenSizeService.notifyResize();
    window.addEventListener("resize", () =>
      this.screenSizeService.notifyResize()
    );

    this.footerMarginService.updateComponent("ComparisonComponent");
    this.id = this.activatedRoute.snapshot.params.id;
    this.quotationId = this.activatedRoute.snapshot.queryParams.id;
    this.ref = this.activatedRoute.snapshot.queryParams.ref;
    this.lang = this.activatedRoute.snapshot.queryParams.lang;

    if (!this.id) {
      window.location.href = "/";
    }

    // Check if quotation expired by getQuotationById()
    // if expired reroute to renew-quotation page
    const quotationExpired = await this.checkIfQuotationExpiredOnce();

    if (!quotationExpired) {
      if (!this.isAllQuotationUpdated()) {
        this.signalRService.startConnection().subscribe((isConnected) => {
          this.updateQuotationMethod(isConnected);
        });
      }

      if (this.ref == "email") {
        this.gtmService.pushTag({
          event: "link_clicked",
          source: "email"
        });
      }
      this.getPersonalInfo();
      this.getAdditionalInsurer();
      this.initQuotationForm();
      this.initAgreementForm();
      this.initPersonalDetailsForm();
      this.initAddOnForm();
      this.initPaymentFormGroup();
      this.pushCleverTapPageView(0);
    }

    this.activatedRoute.queryParams.subscribe((x) => {
      if (x.id && !this.data && !this.selectedQuotation) {
        this.selectQuotation(x.id);
      }
    });

  }

  ngOnDestroy(): void {
    this.footerMarginService.updateComponent(null);
    // Clean up subscriptions and other resources
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
    this.timerUnsubscribe$.next();
    this.timerUnsubscribe$.complete();
  }

  ngAfterContentChecked() {
    this.cd.detectChanges();
  }

  onStepChange(e: any) {
    if (this.originalSelectedAddon.length === 0) {
      this.originalSelectedAddon.push(
        ...this.selectedAddOn.map((addOn) => ({ ...addOn }))
      );
    }
    if (e.selectedIndex == 0 || e.selectedIndex == 3)
      this.footerMarginService.updateComponent("ComparisonComponent");
    else this.footerMarginService.updateComponent("PlansComponent");

    if (e.selectedIndex == 0) {
      //Clear route params if returning to insurer page
      if (this.lang == "en") {
        this.router.navigate([], {
          queryParams: {
            id: null,
            lang: this.lang
          },
          queryParamsHandling: "merge"
        });
      }
    }

    //Triggered after Personal Details page
    if (e.selectedIndex == 3) {
      this.pushCleverTapPersonalDetails();

      if (this.excessData?.length) this.pushCleverTapExcessSelection();
    }

    if (
      (this.isGeneraliIQ || this.isTMIMIQ || this.isZurichIQ) &&
      e.previouslySelectedIndex === 1
    ) {
      this.recalculateQuotationPricing();
    }

    if (
      this.isTMIMIQ &&
      e.previouslySelectedIndex === 2 &&
      e.selectedIndex === 1
    ) {
      this.selectedAddOn = this.originalSelectedAddon.map((addOn) => ({
        ...addOn
      }));
      this.selectedAddOnToDisplay = this.selectedAddOn.map((addOn) => ({
        ...addOn
      }));
    }

    this.pushCleverTapPageView(e.selectedIndex);
  }

  async checkEligibilityForGamification() {
    
        let request: SubmitCustomerInfoRequest = {
          vehicleNo: this.personalInfo.vehicleNo,
          postcode: this.personalInfo.postcode,
          mobileNo: this.personalInfo.mobileNo,
          email: this.personalInfo.email,
          isMalaysian: this.personalInfo.isMalaysian,
          isCompany: this.personalInfo.isCompany,
          isCommercialIndividual: false,
          isCommercialCompany: false,
          name: this.personalInfo.name,
          nationality: this.personalInfo.isMalaysian ? "Malaysian" : this.personalInfo.nationality,
          dob: this.personalInfo.dob,
          gender: this.personalInfo.gender,
          identityNo: this.personalInfo.identityNo,
          policIdentityNo: this.personalInfo.policIdentityNo,
          insuranceType: this.personalInfo.insuranceType
        };
    
        let form: any = new FormData();
        for (const [key, value] of Object.entries(request) as [string, any][]) {
          if (value === null || value === undefined || value === "") continue;
    
          if (key === "dob") {
            form.append(key, value.toString());
          } else {
            form.append(key, value);
          }
        }
    
        this.motorQuotationDataService
          .checkEligibilityForGamification(form)
          .subscribe({
            next: (x) => {
              let isEligible = x;
              if (isEligible) {
                // this.isLoading = false;
                this.dialog.open(NewUserGamificationComponent, {
                  // panelClass: "no-padding-border-radius-dialog",
                  data: {
                    email: this.personalInfo.email,
                    vehicleNo: this.personalInfo.vehicleNo,
                    identityNo: this.personalInfo.identityNo
                  }
                });
              } else {
                console.log("not eligible for gamification");
              }
            },
            error: (_error: any) => {
              // this.isLoading = false;
            }
          });
      }

  recalculateQuotationPricing() {
    // Removed this.selectedAddOn checking to let the IQ recalculate everytime
    //  - else, if customer deselect previously selected addon and proceed, and the selectedAddOn is now empty, the GET PREM is not executed and updated
    //  - and the result will be incorrect
    this.loadingService.setLoading(true);
    const handleResponse = {
      next: (x: any) => {
        this.selectedAddOn = x;
        // Sync evaluate values from this.selectedaddon to this.selectedaddontodisplay
        this.selectedAddOnToDisplay.forEach((displayItem) => {
          const matchingItem = this.selectedAddOn.find(
            (addOn) => addOn.id === displayItem.id
          );
          if (matchingItem) {
            displayItem.evaluate = matchingItem.evaluate;
          }
        });
        this.loadingService.setLoading(false);
      },
      error: () => {
        this.alertService.openSnackBar(
          "Premium calculation failed, please contact Policy Street."
        );
        this.loadingService.setLoading(false);
        this.stepper.selectedIndex = 1;
      }
    };

    if (this.isTMIMIQ) {
      let driverCount = 0;
      if (this.selectedAddOn.some((i) => i.insurerCustomCode === "E303")) {
        driverCount =
          (this.addOnFormGroup.get("drivers") as FormArray)?.length ?? 0;
      }
      this.motorDataDataService
        .getTMIMQuotationPricing(
          this.selectedAddOn,
          this.addOnFormGroup.controls.windshield.value,
          this.quotationId,
          driverCount
        )
        .subscribe(handleResponse);
    } else if (this.isGeneraliIQ) {
      this.motorDataDataService
        .getGeneraliQuotationPricing(
          this.quotationId,
          this.selectedAddOn,
          this.addOnFormGroup.value.drivers,
          this.addOnFormGroup.controls.windshield.value,
          this.addOnFormGroup.controls.gckt.value,
          this.addOnFormGroup.controls.cartDays.value,
          this.addOnFormGroup.controls.cartDailyCoverage.value
        )
        .subscribe(handleResponse);
    }

    //Zurich / Zurich Takaful
    else if (this.isZurichIQ) {
      let isZurichTakaful =
        this.selectedQuotation.name == INSURER_FULL_NAME.Zurich_Takaful
          ? true
          : false;

      this.motorDataDataService
        .getZurichQuotationPricing(
          this.quotationId,
          this.selectedAddOn,
          this.addOnFormGroup.controls.windshield.value,
          isZurichTakaful
        )
        .subscribe(handleResponse);
    }
  }

  private async getBundleData(
    quotation: D2CQuotationInterface
  ): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.motorBundleService
        .getMotorBundleAddOn(this.id, quotation.id)
        .subscribe({
          next: (x) => {
            this.isLoadingBundleData = false;
            this.data = x;
            this.data.bundleId = quotation.id;

            // manually add isBundleAddOn flag
            let adjustedMotorBundleAddOn = this.data.motorBundleAddOn.map(
              (addOn) => {
                addOn.isBundleAddOn = true;
                return addOn;
              }
            );

            let adjustedMotorAddOn = this.data.motorAddOn.map((addOn) => {
              addOn.isBundleAddOn = false;
              return addOn;
            });

            let vehicleAge: number =
              new Date().getFullYear() - this.personalInfo.year;

            if (vehicleAge > 10 && quotation.name === "Generali") {
              adjustedMotorAddOn = adjustedMotorAddOn.filter(
                (obj) => obj.code !== "EHailing"
              );
            }

            // join motorAddOn and motorBundleAddOn then sort by sequence
            this.consolidatedAddOn = [
              ...adjustedMotorAddOn,
              ...adjustedMotorBundleAddOn
            ];

            // set seq = 0 if is included
            this.consolidatedAddOn
              .filter((addOn) => addOn.included == true)
              .map((addOn) => {
                addOn.seq = 0;
                return addOn;
              });

            // add road tax renewal to consolidatedAddOn
            if (!this.isEHailing) {
              let roadTaxRenewalAddOn = {
                category: null,
                code: null,
                condition: null,
                createdDate: null,
                customCode: null,
                description: null,
                evaluate: null,
                explanation: null,
                hidePriceBreakdown: false,
                id: null,
                imageUrl: null,
                included: false,
                includedInBundle: false,
                insuranceType: null,
                isActive: null,
                isConditionFirst: true,
                isPopular: true,
                modifyDate: null,
                motorAddOnId: null,
                motorBundleId: null,
                motorPartnerId: null,
                motorProductId: null,
                rules: null,
                seq: 1,
                isRoadTaxRenewal: true
              };
              this.consolidatedAddOn.push(roadTaxRenewalAddOn);
            }

            // sort consolidatedAddOn by seq
            this.consolidatedAddOn.sort((a, b) => a.seq - b.seq);

            // get driver add on count
            this.driverAddOnCount = this.consolidatedAddOn.filter(
              (addOn) => addOn.category === "Drivers"
            ).length;

            // populate driversAddOn
            this.driversAddOn = this.consolidatedAddOn.filter(
              (addOn) => addOn.category === "Drivers"
            );

            this.keepFirstDrivers();

            // populate popularConsolidatedAddOn
            this.popularConsolidatedAddOn = this.consolidatedAddOn.filter(
              (addOn) => addOn.isPopular == true
            );

            // set addOnListToDisplay to display all by default
            this.addOnListToDisplay = this.consolidatedAddOn;
            this.hasRoadtaxAddon = this.consolidatedAddOn.some(
              (addon) => addon.isRoadTaxRenewal === true
            );

            this.setDisplayCodeForInsurers();

            this.includedAddOn = [
              ...new Set(this.data.motorAddOn.filter((y) => y.included))
            ];

            this.data.motorAddOn.forEach((y) => {
              if (y.category == "Windshield") {
                this.addOnFormGroup.controls.windshield.setValue(
                  this.getMinMaxWindscreenPrice(y, "min")
                );
              }
              if (y.code == "AdditionalDrivers") {
                this.maxAdditionalDriver = this.getRule(y)?.max ?? null;
                this.maxFreeDriver = !y.condition
                  ? this.getRule(y)?.max ?? null
                  : null;
              }
              if (y.category == "CART") {
                this.selectedCartDays = this.cartDayList[0].codeValue;
                this.selectedCartDailyCoverage =
                  this.cartDailyCoverageList[0].codeValue;
                this.addOnFormGroup.controls.cartDays.setValue(
                  this.selectedCartDays
                );
                this.addOnFormGroup.controls.cartDailyCoverage.setValue(
                  this.selectedCartDailyCoverage
                );
              }
              if (y.category == "GCKT") {
                this.minGCKTCoverage = this.getRule(y)?.min ?? null;
                this.addOnFormGroup.controls.gckt.setValue(
                  this.minGCKTCoverage
                );
              }
              if (y.category == "VA") {
                this.minVACoverage = this.getRule(y)?.min ?? null;
                this.addOnFormGroup.controls.va.setValue(this.minVACoverage);
              }
            });
            resolve(true);
          }
        });
    });
  }

  private keepFirstDrivers() {
    // Find the first occurrence of the category "Drivers"
    const firstDriversIndex = this.consolidatedAddOn.findIndex(
      (addOn) => addOn.category === "Drivers"
    );

    // If there's no "Drivers" category do nothing
    if (firstDriversIndex === -1) {
      return;
    }

    // Keep the first "Drivers" and all other categories, excluding other "Drivers"
    this.consolidatedAddOn = [
      ...this.consolidatedAddOn.filter(
        (addOn, index) =>
          addOn.category !== "Drivers" || index === firstDriversIndex
      )
    ];
  }

  private async checkIfQuotationExpiredOnce(): Promise<boolean> {
    this.loadingService.setLoading(true);
    let quotation;

    try {
      quotation = await this.motorDataDataService
        .getQuotationById(this.id)
        .toPromise();

      if (quotation.hasOwnProperty("expiredDetails")) {
        this.quotationExpiredData = quotation;
        const expiredDetails = this.quotationExpiredData.expiredDetails;
        if (expiredDetails.hasOwnProperty("isResubmitted")) {
          await this.router.navigate(["/quotation/renew/", this.id], {
            state: { quotationDetails: this.quotationExpiredData },
            queryParams: { id: this.quotationId }
          });
          this.loadingService.setLoading(false);
          return true;
        }
      } else {
        this.quotationIsExpired = false;
        this.quotationList = quotation;
        this.loadingService.setLoading(false);
        return false;
      }
    } catch (err) {
      console.error("Error occurred:", err);
      this.loadingService.setLoading(false);
      window.location.href = "/";
      return false;
    }

    return true;
  }

  private async checkIfQuotationExpired(): Promise<boolean> {
    this.loadingService.setLoading(true);
    let quotation;

    try {
      quotation = await this.motorDataDataService
        .getQuotationById(this.id)
        .toPromise();

      if (quotation.hasOwnProperty("expiredDetails")) {
        this.quotationExpiredData = quotation;
        const expiredDetails = this.quotationExpiredData.expiredDetails;
        if (expiredDetails.hasOwnProperty("isResubmitted")) {
          await this.router.navigate(["/quotation/renew/", this.id], {
            state: { quotationDetails: this.quotationExpiredData },
            queryParams: { id: this.quotationId }
          });
          this.loadingService.setLoading(false);
          return true;
        }
      } else {
        this.quotationIsExpired = false;
        this.quotationList = quotation;

        const hasNewQuotation = this.quotationList.some(
          (item) => item.status === "New"
        );

        if (hasNewQuotation) {
          // Start or restart the timer if needed
          this.timerService.startTimer();

          // Ensure only one subscription to the timerExpired$ observable
          if (!this.timerSubscription) {
            this.timerSubscription = this.timerService.timerExpired$
              .pipe(takeUntil(this.timerUnsubscribe$))
              .subscribe(() => {
                // Call the function again after timer expires
                this.checkIfQuotationExpired();
              });
          }
        } else {
          // Stop the timer and clean up subscription if no new quotations
          this.timerService.stopTimer();
          if (this.timerSubscription) {
            this.timerSubscription.unsubscribe();
            this.timerSubscription = null;
          }
        }

        this.loadingService.setLoading(false);
        return false;
      }
    } catch (err) {
      console.error("Error occurred:", err);
      this.loadingService.setLoading(false);
      window.location.href = "/";
      return false;
    }

    return true;
  }
  private getExcessList(id: string) {
    this.motorDataDataService.getAccessList(id).subscribe({
      next: (x) => {
        this.excessData = x;
        this.applyExcessDiscount();
      }
    });
  }

  private applyExcessDiscount() {
    // If no excess, show excess
    if (!this.selectedExcess) {
      let defaultExcess = this.excessData?.filter(
        (x) => x.name == HIGHER_EXCESS
      );
      let defaultPrice;
      let condition = defaultExcess[0]?.premiumDiscountEvaluate?.replace(
        "{bp}",
        this.selectedQuotation.basePremium
      );
      if (condition && Boolean(eval(condition))) {
        defaultPrice = eval(condition);
      }
      this.selectedExcess = {
        name: defaultExcess[0]?.name,
        price: defaultPrice,
        id: defaultExcess[0]?.id
      };
    }
  }

  private removeExcessDiscount() {
    if (this.selectedExcess) {
      this.selectedExcess = null;
    }
  }

  changeExcess(data: any) {
    this.selectedExcess = data;
    this.pushCleverTapExcessSelection();
  }

  async selectQuotation(id: string) {
    this.isLoadingBundleData = true;
    this.quotationFormGroup.controls.id.setValue(id);

    this.selectedQuotation = await this.quotationList.find((x) => x.id == id);

    // Remove all selected add on, if insurer selected is different
    if (this.quotationId && this.quotationId != id) {
      this.selectedMotorMembership = [];
      this.selectedAddOn = [];
      this.selectedAddOnToDisplay = [];
      this.selectedPsxtraAddOnToDisplay = [];
      this.selectedMotorMembershipLockDeal = [];
    }
    this.quotationId = id;

    this.isTakaful = this.selectedQuotation.isTakaful;
    this.isAllianzQuotation = this.selectedQuotation.name == "Allianz";

    this.getProductDocument();
    if (this.isPolicystreetProduct)
      this.getExcessList(this.selectedQuotation.id);
    else this.removeExcessDiscount();

    //To refactor in the future. If selected quotation is TI, update the validator
    if (this.selectedQuotation?.code == "Ikhlas") {
      this.agreementFrmGroup.controls.aqadTC.setValidators([
        Validators.requiredTrue
      ]);
    }

    // Run bundle data api only if selectedId is different from previous Id
    if (!this.data || this.data.bundleId !== id) {
      await this.getBundleData(this.selectedQuotation);
      await this.getAvailableSalesCampaign();
      await this.getMotorMembership();
    } else {
      this.isLoadingBundleData = false;
    }

    if (this.data) {
      this.stepper.next();
      if (this.lang == "en") {
        this.router.navigate([], {
          queryParams: {
            id: this.selectedQuotation.id,
            lang: this.lang
          }
        });
      }

      this.pushCleverTapSelectedInsurer();
    } else {
      window.location.href = "/";
    }

    this.isGeneraliIQ =
      this.selectedQuotation.name == "Generali" &&
      this.selectedQuotation.isInstantQuotation;
    this.isTMIMIQ =
      this.selectedQuotation.name == "Tokio Marine" &&
      this.selectedQuotation.isInstantQuotation;
    this.isZurichIQ =
      (this.selectedQuotation.name == INSURER_FULL_NAME.Zurich ||
        this.selectedQuotation.name == INSURER_FULL_NAME.Zurich_Takaful) &&
      this.selectedQuotation.isInstantQuotation;

    // Generali's CART does not have RM 200 options
    if (this.isGeneraliIQ) {
      this.cartDailyCoverageList = this.cartDailyCoverageList.filter(
        (x) => parseInt(x.codeValue) < 200
      );
    }
  }

  private getMotorMembership() {
    this.motorDataDataService
      .getMotorMembership(this.id, this.quotationId)
      .subscribe({
        next: (x) => {
          this.motorMembershipList = x.membership;

          this.drivePlusLiteAddon =
            this.motorMembershipList.find((x) => x.code === "DrivePlusLite") ||
            null;
          this.drivePlusStandardAddon =
            this.motorMembershipList.find(
              (x) => x.code === "DrivePlusStandard"
            ) || null;
          this.drivePlusPremiumAddon =
            this.motorMembershipList.find(
              (x) => x.code === "DrivePlusPremium"
            ) || null;

          this.defaultMotorMembership = this.motorMembershipList.filter(
            (x) => x.isDefault
          );
          this.motorMembershipBenefits = x.membershipBenefit;
          this.motorMembershipRenewalDiscount = x.memberRenewalDiscount;
          this.motorMembershipLockDeal = x.membershipLockDeal;
          this.motorMembershipBenefitsLockDeal = x.membershipBenefitLockDeal;

          /* Remove AtomeDiscount from display */
          this.motorMembershipBenefitsDisplay = x.membershipBenefit.filter(
            (x) => x.code !== "AtomeDiscount"
          );
          this.motorMembershipBenefitsLockDealDisplay =
            x.membershipBenefit.filter((x) => x.code !== "AtomeDiscount");

          let isLockedDeal = this.motorMembershipLockDeal.length ? true : false;
          let membershipList = isLockedDeal
            ? this.motorMembershipLockDeal.find((x) => x.code === "DrivePlus")
            : this.motorMembershipList.find((x) => x.isDefault);
          this.callToggleMotorMembership(true, membershipList, isLockedDeal);
        },
        error: () => {
          window.location.href = "/";
        }
      });
  }

  private getPersonalInfo() {
    this.motorDataDataService.getDetailById(this.id).subscribe({
      next: (x) => {
        this.personalInfo = x;
        this.isEHailing = x.eHailingUsed;
        this.getPersonalDetailsCardData();
        this.setIdTypeAndFillForm();

        if (this.personalInfo.language && !this.lang) {
          if (this.lang == "en") {
            this.router.navigate([], {
              queryParams: { lang: this.personalInfo.language },
              queryParamsHandling: "merge", // keeps existing params
              replaceUrl: true // optional: avoids adding to browser history
            });
          }
          this.translate.use(this.personalInfo.language);
        } else {
          if (this.lang == "en") {
            this.router.navigate([], {
              queryParams: { lang: this.lang },
              queryParamsHandling: "merge", // keeps existing params
              replaceUrl: true // optional: avoids adding to browser history
            });
          }
          this.translate.use(this.lang);
        }

        this.numberOfLltpSeats = x.seat;
        if (this.numberOfLltpSeats <= 4) {
          this.numberOfLltpSeats = 5;
        }
        this.checkEligibilityForGamification();
      },
      error: () => {
        window.location.href = "/";
      }
    });
  }

  private getAdditionalInsurer() {
    this.motorDataDataService.getAvailableProduct(this.id).subscribe({
      next: (x: OtherInsurerInterface[]) => {
        this.otherInsurerList = x;
      },
      error: () => {
        // window.location.href = "/";
      }
    });
  }

  private getAvailableSalesCampaign() {
    this.motorDataDataService.getAvailableSalesCampaign(this.id).subscribe({
      next: (x) => {
        this.availableSalesCampaign = x;
        this.getCampaignPrice();
      },
      error: () => {
        console.log("Failed to retrieve available campaigns.");
      }
    });
  }

  private getPersonalDetailsCardData() {
    this.personalDetailsCardData = [
      {
        title: this.getNameLabel(),
        value: this.personalInfo?.name
      },
      {
        title: this.getIdentityNoLabel(),
        value: this.personalInfo?.identityNo
      },
      {
        title: "common.mobileNo",
        value: this.personalInfo?.mobileNo
      },
      {
        title: "common.emailAddress",
        value: this.personalInfo?.email
      }
    ];

    let companyCase = this.personalInfo?.isCompany;
    if (companyCase) {
      // Insert new row of details after Representative Name
      this.personalDetailsCardData.splice(1, 0, {
        title: "common.companyIC",
        value: this.personalInfo.bizRepIcNo
      });

      // Insert new row of details after Business Reg No.
      this.personalDetailsCardData.splice(3, 0, {
        title: "common.oldBusinessRegistrationNo",
        value: this.personalInfo.oldBizRegNo
      });
    }

    this.personalDetailsCardData.push(
      {
        title: "common.maritalStatus",
        value: companyCase
          ? "-"
          : this.personalInfo?.maritalStatus == "Single"
          ? "common.Single"
          : this.personalInfo?.maritalStatus == "Married"
          ? "common.Married"
          : "-",
        translateValue: true
      },
      {
        title: "common.gender",
        value: companyCase
          ? "-"
          : this.personalInfo?.gender == "M"
          ? "common.M"
          : this.personalInfo?.gender == "F"
          ? "common.F"
          : "-",
        translateValue: true
      }
    );
  }

  setIdTypeAndFillForm(): void {
    switch (true) {
      case this.personalInfo?.isMalaysian &&
        !this.personalInfo?.isCompany &&
        this.personalInfo?.policIdentityNo !== null:
        this.idType = this.idTypeOption.police;
        break;
      case this.personalInfo?.isMalaysian &&
        !this.personalInfo?.isCompany &&
        !this.personalInfo?.policIdentityNo:
        this.idType = this.idTypeOption.malaysian;
        break;
      case this.personalInfo?.isMalaysian && this.personalInfo?.isCompany:
        this.idType = this.idTypeOption.company;
        this.infoFormGroup.controls.name.setValidators([]);
        break;
      case !this.personalInfo?.isMalaysian &&
        !this.personalInfo?.isCompany &&
        this.personalInfo?.nationality !== null:
        this.idType = this.idTypeOption.foreigner;
        break;
      default:
        break;
    }
    this.infoFormGroup.patchValue({
      name: this.personalInfo?.name,
      nationality: this.personalInfo?.nationality,
      identityNo: this.personalInfo?.identityNo,
      oldBizRegNo: this.personalInfo?.oldBizRegNo,
      policIdentityNo: this.personalInfo?.policIdentityNo,
      mobileNo: this.personalInfo?.mobileNo,
      email: this.personalInfo?.email,
      maritalStatus: this.personalInfo?.maritalStatus,
      gender: this.personalInfo?.gender
    });

    // For Generali IQ, company cases requires TIN (and SST Reg No as optional)
    //  - this is for full journey integration
    //  - might need to do the same for other insurers when integrated with full journey
    if (this.checkIsGeneraliCompanyQuotation()) {
      this.infoFormGroup.controls.TIN.setValidators([
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(14),
        Validators.pattern("^[A-Z][A-Z0-9]+$")
      ]);
      this.infoFormGroup.controls.SSTRegNo.setValidators([
        Validators.pattern("(^$)|(^[A-Z][A-Z0-9]{14,16}$)")
      ]);
    } else {
      this.infoFormGroup.controls.TIN.setValidators([]);
      this.infoFormGroup.controls.SSTRegNo.setValidators([]);
    }

    this.infoFormGroup.controls.TIN.updateValueAndValidity();
    this.infoFormGroup.controls.SSTRegNo.updateValueAndValidity();
  }

  getNameLabel() {
    if (
      !this.personalInfo?.isCompany &&
      this.personalInfo?.nationality !== null
    )
      return "common.namePerPassport";
    else if (this.personalInfo?.isCompany) return "common.companyName";
    else return "common.fullNamePerICPassport";
  }

  getIdentityNoLabel() {
    if (
      !this.personalInfo?.isCompany &&
      this.personalInfo?.nationality !== null
    )
      return "common.passport";
    else if (this.personalInfo?.isCompany)
      return "common.businessRegistrationNo";
    return "common.icNoLabel";
  }

  get isPaymentProviderShopback() {
    return (
      this.paymentFormGroup?.value?.paymentProvider ==
      this.paymentOptionShopback
    );
  }

  get isPaymentTypeEPP() {
    return this.paymentFormGroup?.value?.paymentType == this.paymentOptionEPP;
  }

  get showBankInstallmentCharges() {
    return (
      this.paymentFormGroup?.value?.paymentType == this.paymentOptionEPP &&
      this.paymentFormGroup?.value?.bank &&
      this.paymentFormGroup?.value?.installmentMonth
    );
  }

  get isPaymentTypeBNPL() {
    return this.paymentFormGroup?.value?.paymentType == "BNPL";
  }

  get insurerFullName(): string {
    if (this.selectedQuotation && this.selectedQuotation.code) {
      return INSURER_FULL_NAME[this.selectedQuotation.code];
    }
    return "";
  }

  allAddonChipSelected($event): void {
    if ($event.selected) this.addOnListToDisplay = this.consolidatedAddOn;
  }

  popularAddonChipSelected($event): void {
    if ($event.selected)
      this.addOnListToDisplay = this.popularConsolidatedAddOn;
  }

  // Forms
  private initQuotationForm() {
    this.quotationFormGroup = new FormGroup({
      id: new FormControl(this.quotationId, [Validators.required])
    });
  }
  private initPersonalDetailsForm() {
    this.infoFormGroup = new FormGroup({
      name: new FormControl(null, Validators.required),
      nationality: new FormControl({ value: "", disabled: true }),
      identityNo: new FormControl({ value: "", disabled: true }),
      oldBizRegNo: new FormControl({ value: "", disabled: true }),
      policIdentityNo: new FormControl({ value: "", disabled: true }),
      mobileNo: new FormControl(null, Validators.required),
      email: new FormControl(null, [Validators.required, Validators.email]),
      maritalStatus: new FormControl({ value: "", disabled: true }),
      gender: new FormControl({ value: "", disabled: true }),

      address1: new FormControl(null, [Validators.required]),
      address2: new FormControl(null, [Validators.required]),
      city: new FormControl(null, [Validators.required]),
      state: new FormControl(null, [Validators.required]),

      deliveryAddress1: new FormControl(null),
      deliveryAddress2: new FormControl(null),
      deliveryCity: new FormControl(null),
      deliveryPostcode: new FormControl(null),
      deliveryState: new FormControl(null),

      TIN: new FormControl(null),
      SSTRegNo: new FormControl(null)
    });
  }

  private initAgreementForm() {
    this.agreementFrmGroup = new FormGroup({
      agreeInfo: new FormControl(false),
      aqadTC: new FormControl(false),
      doc: new FormArray([]),
      marketingConsent: new FormControl(false)
    });
  }

  private initAddOnForm() {
    this.getCARTAddOnPriceList();

    this.addOnFormGroup = new FormGroup({
      windshield: new FormControl(),
      drivers: new FormArray([]),
      roadTaxPrice: new FormControl(this.personalInfo?.roadTaxPrice),
      isIncludeRoadtax: new FormControl(false),
      isNotBlacklisted: new FormControl(null),
      isWindshieldExceeded: new FormControl(null),
      lltpSeats: new FormControl(this.numberOfLltpSeats[0]),
      cartDays: new FormControl(),
      cartDailyCoverage: new FormControl(),
      gckt: new FormControl(),
      va: new FormControl()
    });
    this.addOnFormGroup.controls.roadTaxPrice.setValue(
      this.personalInfo?.roadTaxPrice
    );

    this.addOnFormGroup.controls.isIncludeRoadtax.valueChanges.subscribe(
      (x) => {
        if (x) {
          this.addOnFormGroup.controls.isNotBlacklisted.setValidators([
            Validators.requiredTrue
          ]);
        } else {
          this.addOnFormGroup.controls.isNotBlacklisted.setValidators([]);
        }
        this.addOnFormGroup.controls.isNotBlacklisted.updateValueAndValidity();
      }
    );
    this.addOnFormGroup.get("windshield")?.valueChanges.subscribe(() => {
      this.clearPromoCode();
    });

    this.addOnFormGroup.controls.cartDays.valueChanges.subscribe((x) => {
      if (x) {
        this.selectedCartDays = x;
      }
    });

    this.addOnFormGroup.controls.cartDailyCoverage.valueChanges.subscribe(
      (x) => {
        if (x) {
          this.selectedCartDailyCoverage = x;
        }
      }
    );
  }

  private initPaymentFormGroup() {
    this.getEppRateList();
    this.getBNPLRateList();

    this.paymentFormGroup = new FormGroup({
      paymentType: new FormControl(this.paymentOptionFullPrice, [
        Validators.required
      ]),
      paymentProvider: new FormControl(this.paymentOptionRazer, [
        Validators.required
      ]),
      paymentChannel: new FormControl("", []),
      ewalletType: new FormControl("", []),
      fpxEnterpriseType: new FormControl("", []),
      // For EPP only
      bank: new FormControl("", []),
      installmentMonth: new FormControl(0, []),
      paymentOptionEPPType: new FormControl("", []),
      paymentOptionFPType: new FormControl(this.paymentOptionRazer, [
        Validators.required
      ])
    });

    let paymentFormVal = this.paymentFormGroup.controls;
    let paymentChannel = this.paymentFormGroup.controls.paymentChannel;
    let paymentProvider = this.paymentFormGroup.controls.paymentProvider;
    let ewalletType = this.paymentFormGroup.controls.ewalletType;
    let fpxEnterpriseType = this.paymentFormGroup.controls.fpxEnterpriseType;

    // Change EPP rate on bank change
    this.paymentFormGroup.controls.bank.valueChanges.subscribe((x) => {
      if (x) {
        this.getIndividualEppRates(x);
        this.pushCleverTapPaymentOptionSelected();
      }
    });

    // Change Monthly Payment Option for EPP
    this.paymentFormGroup.controls.installmentMonth.valueChanges.subscribe(
      (x) => {
        if (
          x &&
          this.paymentFormGroup.value.paymentType == this.paymentOptionEPP
        ) {
          this.pushCleverTapPaymentOptionSelected();
        }
      }
    );

    // To toggle e-wallet / Fpx Enterprise dropdown to be required/not
    this.paymentChannelSub =
      this.paymentFormGroup.controls.paymentChannel.valueChanges.subscribe(
        (x) => {
          if (x == this.paymentOptionEwallet) {
            ewalletType?.setValidators([Validators.required]);
          } else if (x == this.paymentOptionFpxEnterprise) {
            fpxEnterpriseType?.setValidators([Validators.required]);
          } else {
            ewalletType?.setValidators([]);
            fpxEnterpriseType?.setValidators([]);
          }
          ewalletType?.updateValueAndValidity();
          fpxEnterpriseType?.updateValueAndValidity();
        }
      );

    // To toggle other payment type child inputs to be required/not
    this.paymentTypeChangeSub =
      this.paymentFormGroup.controls.paymentType.valueChanges.subscribe((x) => {
        if (x == this.paymentOptionFullPrice) {
          paymentChannel.setValidators([]);
          this.paymentFormGroup.patchValue({
            paymentProvider: this.paymentOptionRazer
          });
          paymentFormVal?.paymentOptionFPType.setValidators([
            Validators.required
          ]);
        } else {
          paymentChannel.setValidators([]);
        }

        if (x == this.paymentOptionEPP) {
          paymentFormVal?.bank.setValidators([Validators.required]);
          paymentFormVal?.installmentMonth.setValidators([Validators.required]);
          paymentProvider.setValidators([Validators.required]);
          paymentFormVal?.paymentOptionEPPType.setValidators([
            Validators.required
          ]);
          paymentFormVal?.paymentOptionFPType.setValidators([]);
          paymentFormVal.ewalletType.reset();
          paymentFormVal.paymentChannel.reset();

          this.paymentFormGroup.patchValue({
            paymentOptionFPType: "",
            bank: "",
            installmentMonth: ""
          });
        } else {
          paymentFormVal?.bank.setValidators([]);
          paymentFormVal?.installmentMonth.setValidators([]);
          paymentFormVal?.paymentOptionEPPType.setValidators([]);
          paymentFormVal.bank.reset();
          paymentFormVal.installmentMonth.reset();
          paymentFormVal.paymentOptionEPPType.reset();
        }

        if (x == this.paymentOptionShopback) {
          paymentChannel.setValidators([]);
          paymentFormVal?.bank.setValidators([]);
          paymentFormVal?.installmentMonth.setValidators([]);
          paymentFormVal?.paymentOptionFPType.setValidators([]);

          paymentFormVal.bank.reset();
          paymentFormVal.installmentMonth.reset();
          paymentFormVal.ewalletType.reset();

          this.paymentFormGroup.patchValue({
            paymentProvider: this.paymentOptionShopback,
            paymentChannel: this.paymentOptionShopback,
            paymentOptionFPType: ""
          });
        }

        if (x == this.paymentOptionBNPL) {
          paymentChannel.setValidators([]);
          paymentFormVal?.bank.setValidators([]);
          paymentFormVal?.installmentMonth.setValidators([]);
          paymentFormVal?.paymentOptionFPType.setValidators([]);
          paymentFormVal.bank.reset();
          paymentFormVal.installmentMonth.reset();
          paymentFormVal.ewalletType.reset();
          this.paymentFormGroup.patchValue({
            paymentProvider: this.paymentOptionAtome,
            paymentChannel: this.paymentOptionAtome,
            bank: "",
            installmentMonth: "",
            paymentOptionEPPType: "",
            ewalletType: "",
            paymentOptionFPType: ""
          });
        }

        paymentChannel.updateValueAndValidity();
        paymentFormVal?.bank.updateValueAndValidity();
        paymentFormVal?.installmentMonth.updateValueAndValidity();

        this.pushCleverTapPaymentOptionSelected();
      });
  }
  // End forms

  private getBNPLRateList() {
    this.motorDataDataService.getBNPLRateListByPortal("d2c").subscribe({
      next: (x: BNPLRateListInterface[]) => {
        this.bnplRateList = x;
      }
    });
  }

  private getEppRateList(promoCodeId: string = null) {
    this.motorDataDataService.getEPPRates(promoCodeId).subscribe({
      next: (x: EPPChargeInterface[]) => {
        this.eppChargeList = x;
      }
    });
  }

  getEppRate() {
    let bankName = this.paymentFormGroup?.value?.bank;
    let paymentProvider = this.paymentFormGroup?.value?.paymentProvider;
    let installmentPeriod = this.paymentFormGroup?.value?.installmentMonth;

    if (bankName && installmentPeriod && this.eppChargeList?.length) {
      const result = this.eppChargeList?.filter(
        (entry) =>
          entry.bankName == bankName &&
          entry.installmentPeriod == installmentPeriod &&
          entry.provider == paymentProvider
      );
      return result.length > 0 ? result[0]?.eppRate : null;
    } else {
      return null;
    }
  }

  getIndividualEppRates(x) {
    let bankName = x;
    let paymentProvider = this.paymentFormGroup?.value?.paymentProvider;

    if (bankName && this.eppChargeList?.length) {
      const results: any = this.eppChargeList
        .filter(
          (entry) =>
            entry.bankName == bankName && entry.provider == paymentProvider
        )
        .reduce((accumulator, entry) => {
          const periods = [3, 6, 12];
          if (periods.includes(entry.installmentPeriod)) {
            accumulator[entry.installmentPeriod] =
              entry.eppRate *
              (this.getTotalCharge() -
                (this.getTotalPromo() + this.getTotalPromoGamification()) -
                this.memberRenewalDiscountPrice);
            if (accumulator[entry.installmentPeriod] < 0)
              accumulator[entry.installmentPeriod] = 0;
          }
          return accumulator;
        }, {});

      this.bankInstallmentCharge = results;
    } else {
      this.bankInstallmentCharge = { 3: null, 6: null, 12: null };
    }
  }

  deliveryAddressChecked(e: MatCheckboxChange) {
    this.enableDeliveryAddress = e.checked;
    let validatorList = e.checked ? [Validators.required] : [];

    if (e.checked) {
      this.infoFormGroup.controls.deliveryAddress1.reset();
      this.infoFormGroup.controls.deliveryAddress2.reset();
      this.infoFormGroup.controls.deliveryCity.reset();
      this.infoFormGroup.controls.deliveryPostcode.reset();
      this.infoFormGroup.controls.deliveryState.reset();
    }

    this.infoFormGroup.controls.deliveryAddress1.setValidators(validatorList);
    this.infoFormGroup.controls.deliveryAddress2.setValidators(validatorList);
    this.infoFormGroup.controls.deliveryCity.setValidators(validatorList);
    this.infoFormGroup.controls.deliveryPostcode.setValidators(validatorList);
    this.infoFormGroup.controls.deliveryState.setValidators(validatorList);

    this.infoFormGroup.controls.deliveryAddress1.updateValueAndValidity();
    this.infoFormGroup.controls.deliveryAddress2.updateValueAndValidity();
    this.infoFormGroup.controls.deliveryCity.updateValueAndValidity();
    this.infoFormGroup.controls.deliveryPostcode.updateValueAndValidity();
    this.infoFormGroup.controls.deliveryState.updateValueAndValidity();
  }

  backToStep(index: number, toConfirmDriveplus = false) {
    if (toConfirmDriveplus) {
      this.onNextClick();
    } else {
      this.stepper.selectedIndex = index;
    }
  }

  // Bundle functions
  addBundle(item: any) {
    this.selectedBundle.push(item);

    // If bundle selected, remove all add on with the selected bundle ID
    this.selectedBundleAddOn = this.selectedBundleAddOn.filter(
      (x) => x.motorBundleId !== item.id && x.code !== "UnlimitedTowing"
    );
  }

  removeBundle(type: any) {
    this.selectedBundle = this.selectedBundle.filter((e: any) => e !== type);
  }

  getIsBundleSelected(id: string) {
    return this.selectedBundle.some((e: any) => e.id == id);
  }

  getIsBundleAddOnSelected(code: string) {
    return this.selectedBundleAddOn.some((e: any) => e.code == code);
  }

  isAnyBundleSelected() {
    return this.selectedBundle.length > 0;
  }

  toggleBundleAddonCheckbox(e: MatCheckboxChange, type?: any) {
    if (e.checked) {
      this.selectedBundleAddOn.push(type);
      this.pushCleverTapSelectAddOn(type.code);
    }
    if (!e.checked) {
      this.selectedBundleAddOn = this.selectedBundleAddOn.filter(
        (x) => x !== type
      );
    }
    this.clearPromoCode();
  }
  // End Bundle functions

  toggleUnlimitedTowingPlan(display: string) {
    const elements = document.getElementsByClassName("UnlimitedTowing");
    for (let i = 0; i < elements.length; i++) {
      (elements[i] as HTMLElement).style.display = display;
    }
    this.clearPromoCode();
  }

  toggleAddOn(e: MatCheckboxChange, value: any) {
    if (e.checked) {
      if (
        value.code === "MPAPlus" ||
        value.code === "BISP" ||
        value.code === "MERW"
      ) {
        this.toggleUnlimitedTowingPlan("none");
        this.selectedAddOn = this.selectedAddOn.filter(
          (x) => x.category !== "UnlimitedTowing"
        );
        this.selectedAddOnToDisplay = this.selectedAddOnToDisplay.filter(
          (x) => x.category !== "UnlimitedTowing"
        );
      } else if (value.code === "EHailing") {
        this.toggleAddonPlanCard("none", "roadTaxRenewalClass");
      }

      if (value.category === "LLTP") {
        this.addOnFormGroup.controls.lltpSeats.setValue(this.numberOfLltpSeats);
      }

      this.selectedAddOn.push(value);
      this.pushCleverTapSelectAddOn(value.code);

      if (value.category === "PSXTRA") {
        this.selectedPsxtraAddOnToDisplay.push(value);
      } else if (value.category !== "PSXTRA" && !value.isIncludeSST) {
        this.selectedNonSSTAddOnToDisplay.push(value);
      } else {
        this.selectedAddOnToDisplay.push(value);
      }

      if (value.category === "Windshield") {
        if (
          (this.selectedQuotation.code == "Zurich" ||
            this.selectedQuotation.code == "Zurich_Takaful") &&
          !this.personalInfo.isCompany
        ) {
          this.addOnFormGroup.controls.isWindshieldExceeded.setValidators([
            Validators.requiredTrue
          ]);
          this.addOnFormGroup.controls.isWindshieldExceeded.updateValueAndValidity();
        }
      }
    } else {
      if (
        value.code === "MPAPlus" ||
        value.code === "BISP" ||
        value.code === "MERW"
      ) {
        this.toggleUnlimitedTowingPlan("flex");
      } else if (value.code === "EHailing") {
        this.toggleAddonPlanCard("flex", "roadTaxRenewalClass");
      }
      let index = this.selectedAddOn.findIndex((x) => x.id == value.id);
      if (index >= 0) {
        this.selectedAddOn.splice(index, 1);
      }

      let psxtraIndex = this.selectedPsxtraAddOnToDisplay.findIndex(
        (x) => x.id == value.id
      );
      if (psxtraIndex >= 0) {
        this.selectedPsxtraAddOnToDisplay.splice(psxtraIndex, 1);
      }

      let nonSSTIndex = this.selectedNonSSTAddOnToDisplay.findIndex(
        (x) => x.id == value.id
      );
      if (nonSSTIndex >= 0) {
        this.selectedNonSSTAddOnToDisplay.splice(nonSSTIndex, 1);
      }

      let addonIndex = this.selectedAddOnToDisplay.findIndex(
        (x) => x.id == value.id
      );
      if (addonIndex >= 0) {
        this.selectedAddOnToDisplay.splice(addonIndex, 1);
      }

      if (value.category === "Windshield") {
        this.addOnFormGroup.controls.windshield.setValue(
          this.getMinMaxWindscreenPrice(value, "min")
        );

        if (
          (this.selectedQuotation.code == "Zurich" ||
            this.selectedQuotation.code == "Zurich_Takaful") &&
          !this.personalInfo.isCompany
        ) {
          this.addOnFormGroup.controls.isWindshieldExceeded.setValidators([]);
        }
        this.addOnFormGroup.controls.isWindshieldExceeded.updateValueAndValidity();
      }

      if (value.category === "CART") {
        this.selectedCartDays = this.cartDayList[0].codeValue;
        this.selectedCartDailyCoverage =
          this.cartDailyCoverageList[0].codeValue;
        this.addOnFormGroup.controls.cartDays.setValue(this.selectedCartDays);
        this.addOnFormGroup.controls.cartDailyCoverage.setValue(
          this.selectedCartDailyCoverage
        );
      }

      if (value.category === "GCKT") {
        this.addOnFormGroup.controls.gckt.setValue(this.minGCKTCoverage);
      }

      if (value.category === "VA") {
        this.addOnFormGroup.controls.va.setValue(this.minVACoverage);
      }
    }
    if (value.category == "Drivers") {
      let frmArray = this.getDriversFormArray();
      frmArray.reset();
      frmArray.clear();
      if (e.checked && value.code == "AdditionalDrivers") this.addDriver();
    }
    this.clearPromoCode();
  }

  toggleMotorMembership(
    e: MatCheckboxChange | Event, // allow both checkbox and button event
    value: any,
    isLockedDeal: boolean,
    isButton: boolean
  ) {
    // 🔹 Determine if this is from a button or checkbox
    const isChecked = isButton ? true : (e as MatCheckboxChange).checked;
    this.drivePlusTierChecked = isButton
      ? true
      : (e as MatCheckboxChange).checked;

    if (isChecked) {
      if (isLockedDeal) {
        // if button clicked or checkbox checked, clear existing and add this
        if (isButton) this.selectedMotorMembershipLockDeal = [];
        this.selectedMotorMembershipLockDeal.push(value);

        /* Get Benefits */
        const rtHandlingFeeLD = this.motorMembershipBenefitsLockDeal.find(
          (x) =>
            x.motorMembershipId == value.id &&
            x.code == "FreeRoadTaxHandlingFee"
        );
        const eppRateLD = this.motorMembershipBenefitsLockDeal.find(
          (x) => x.motorMembershipId == value.id && x.code == "ZeroEPPRate"
        );
        const atomeDiscLD = this.motorMembershipBenefitsLockDeal.find(
          (x) => x.motorMembershipId == value.id && x.code == "AtomeDiscount"
        );
        const eppDiscLD = this.motorMembershipBenefitsLockDeal.find(
          (x) => x.motorMembershipId == value.id && x.code == "EPPDiscount"
        );
        this.membershipRTHandlingFee = rtHandlingFeeLD
          ? parseFloat(rtHandlingFeeLD.evaluate)
          : null;
        this.membershipEppRate = eppRateLD
          ? parseFloat(eppRateLD.evaluate)
          : null;
        this.membershipAtomeDiscount = atomeDiscLD
          ? parseFloat(atomeDiscLD.evaluate)
          : null;
        this.membershipEppDiscount = eppDiscLD
          ? parseFloat(eppDiscLD.evaluate)
          : null;

        /* Uncheck Current Membership */
        let index = this.selectedMotorMembership.findIndex(
          (x) => x.id == value.id
        );
        if (index >= 0) {
          this.selectedMotorMembership.splice(index, 1);
        }
      } else {
        if (isButton) this.selectedMotorMembership = [];
        if (Array.isArray(value)) {
          this.selectedMotorMembership = value;
        } else {
          this.selectedMotorMembership.push(value);
        }

        /* Get Benefits */
        const rtHandlingFee = this.motorMembershipBenefits.find(
          (x) =>
            x.motorMembershipId == value.id &&
            x.code == "FreeRoadTaxHandlingFee"
        );
        const eppRate = this.motorMembershipBenefits.find(
          (x) => x.motorMembershipId == value.id && x.code == "ZeroEPPRate"
        );
        const atomeDisc = this.motorMembershipBenefits.find(
          (x) => x.motorMembershipId == value.id && x.code == "AtomeDiscount"
        );

        const eppDisc = this.motorMembershipBenefits.find(
          (x) => x.motorMembershipId == value.id && x.code == "EPPDiscount"
        );
        this.membershipRTHandlingFee = rtHandlingFee
          ? parseFloat(rtHandlingFee.evaluate)
          : null;
        this.membershipEppRate = eppRate ? parseFloat(eppRate.evaluate) : null;
        this.membershipAtomeDiscount = atomeDisc
          ? parseFloat(atomeDisc.evaluate)
          : null;
        this.membershipEppDiscount = eppDisc
          ? parseFloat(eppDisc.evaluate)
          : null;

        const codeToMatch = Array.isArray(value) ? value[0]?.code : value?.code;

        this.selectedDrivePlusPackageMembership =
          this.motorMembershipBenefits.filter(
            (b) => b.motorMembershipCode == codeToMatch
          );
        /* Uncheck Locked Deal Membership */
        let index = this.selectedMotorMembershipLockDeal.findIndex(
          (x) => x.id == value.id
        );
        if (index >= 0) {
          this.selectedMotorMembershipLockDeal.splice(index, 1);
        }
      }

      this.pushCleverTapSelectMotorMembership(value.code);
      if (this.hasRoadtaxAddon) {
        this.callToggleRoadTax(true);
        this.isRoadtaxSelected = true;
      }
    } else {
      // existing uncheck behavior (checkbox only)
      let index = null;
      if (isLockedDeal) {
        index = this.selectedMotorMembershipLockDeal.findIndex(
          (x) => x.id == value.id
        );
        if (index >= 0) {
          this.selectedMotorMembershipLockDeal.splice(index, 1);
        }
      } else {
        // index = this.selectedMotorMembership.findIndex(
        //   (x) => x.id == value?.id
        // );
        // if (index >= 0) {
        //   this.selectedMotorMembership.splice(index, 1);
        // }
        this.selectedMotorMembership = [];
      }

      this.selectedDrivePlusPackageMembership = null;
      this.membershipRTHandlingFee = null;
      this.membershipEppRate = null;
      this.membershipAtomeDiscount = null;
      this.membershipEppDiscount = null;

      if (this.hasRoadtaxAddon) {
        this.callToggleRoadTax(false);
        this.isRoadtaxSelected = false;
      }
    }
  }

  toggleRoadTax(e: MatCheckboxChange) {
    let value: any = e.source.value as any;
    if (e.checked) {
      this.toggleAddonPlanCard("none", "EHailing");
      this.showRoadTaxList = true;

      this.addOnFormGroup.controls.isIncludeRoadtax.setValue(true);
      this.isIncludeDigitalRoadtax = true;
      this.pushCleverTapSelectAddOn("Road Tax Renewal");
    }
    if (!this.personalInfo.isMalaysian || this.personalInfo.isCompany) {
      this.addOnFormGroup.controls.isIncludeRoadtax.setValue(true);
      this.addOnFormGroup.controls.roadTaxPrice.setValue(
        this.personalInfo.roadTaxPrice
      );
      this.isIncludeDigitalRoadtax = false;
    }
    if (!e.checked) {
      this.toggleAddonPlanCard("flex", "EHailing");
      this.addOnFormGroup.controls.isIncludeRoadtax.setValue(false);
      this.showRoadTaxList = false;
      this.isIncludeDigitalRoadtax = false;
    }

    this.getCampaignPrice();
    this.clearPromoCode();
  }

  toggleAddonPlanCard(display: string, className: string) {
    const elements = document.getElementsByClassName(className);
    for (let i = 0; i < elements.length; i++) {
      (elements[i] as HTMLElement).style.display = display;
    }
    if (display === "none") {
      if (className === "roadTaxRenewalClass") {
        this.callToggleRoadTax(false);
      } else {
        this.selectedAddOn = this.selectedAddOn.filter(
          (x) => x.category !== className
        );
        this.selectedAddOnToDisplay = this.selectedAddOnToDisplay.filter(
          (x) => x.category !== className
        );
      }
    }
    this.clearPromoCode();
  }

  callToggleRoadTax(checked: boolean) {
    const event: MatCheckboxChange = {
      checked: checked,
      source: {
        value: "RoadTaxCheckbox"
      } as any
    };
    this.toggleRoadTax(event);
  }

  callToggleMotorMembership(
    checked: boolean,
    value: any,
    isLockedDeal: boolean
  ) {
    const event: MatCheckboxChange = { source: null, checked: checked };
    this.toggleMotorMembership(event, value, isLockedDeal, false);
  }

  getPrice(item: ProductAddOnInterface, val?: any) {
    try {
      let evaluate = item.evaluate;
      let customEvaluate = item.customEvaluate;
      let condition = item.condition;

      if (val) {
        evaluate = evaluate.replace("{val}", val);

        if (condition) {
          condition = condition.replace("{val}", val);
          if (item.isConditionFirst) {
            let status = Boolean(eval(condition));
            if (status) {
              return eval(evaluate);
            } else {
              return 0;
            }
          }
        }
      }

      if (
        item.customCode == "ETIQA_FLOOD" &&
        this.selectedAddOn.some((x) => x.code == "Windshield")
      ) {
        evaluate = customEvaluate;
      }

      if (
        item.customCode === "Generali_UnlimitedDrivers" &&
        this.selectedAddOn.some((x) => x.code === "Flood" && !this.isGeneraliIQ)
      ) {
        evaluate = customEvaluate.replace("{val}", val);
      }

      if (item.category === "CART") {
        const cartPrice = this.cartAddOnPriceList.filter(
          (x) =>
            x.days.toString() == this.selectedCartDays &&
            x.coverage.toString() == this.selectedCartDailyCoverage
        );
        evaluate = cartPrice.length > 0 ? cartPrice[0]?.price.toString() : null;
      }

      return eval(evaluate);
    } catch {
      return 0;
    }
  }

  getAtomeDiscount() {
    if (
      this.isPaymentTypeBNPL &&
      this.hasSelectedMotorMembershipCode(this.selectedMotorMembershipString)
    )
      return this.membershipAtomeDiscount ? this.membershipAtomeDiscount : 0;
    else return 0;
  }

  getEppDiscount() {
    if (
      this.isPaymentTypeEPP &&
      this.hasSelectedMotorMembershipCode(this.selectedMotorMembershipString)
    )
      return this.membershipEppDiscount ? this.membershipEppDiscount : 0;
    else return 0;
  }

  getAddOnListByCategory(val: string) {
    return this.data.motorAddOn.filter((x) => x.category == val);
  }

  isAddOnSelected(item: ProductAddOnInterface) {
    if (item) {
      return this.selectedAddOn.some((x) => x.id == item.id);
    }
    return null;
  }

  hasSelectedCode(val: string) {
    return this.selectedAddOn.some((x) => x.code == val);
  }

  hasSelectedCategory(val: string) {
    return this.selectedAddOn.some((x) => x.category == val);
  }

  isMotorMembershipSelected(item: MembershipAddonInterface) {
    if (item) {
      return this.selectedMotorMembership.some((x) => x.id == item.id);
    }
    return null;
  }

  hasSelectedMotorMembershipCode(val: string) {
    return (
      this.selectedMotorMembership.some((x) => x.code == val) ||
      this.selectedMotorMembershipLockDeal.some((x) => x.code == val)
    );
  }

  hasSelectedMotorMembershipCategory(val: string) {
    return this.selectedMotorMembership?.some((x) => x.category == val);
  }

  addonLabel(value: number) {
    return "RM " + value.toFixed(2).toLocaleString();
  }

  isMotorMembershipLockDealSelected(item: MembershipAddonInterface) {
    if (item) {
      return this.selectedMotorMembershipLockDeal.some((x) => x.id == item.id);
    }
    return null;
  }

  hasSelectedMotorMembershipLockDealCategory(val: string) {
    return this.selectedMotorMembershipLockDeal.some((x) => x.category == val);
  }

  private getProductDocument() {
    if (!this.selectedQuotation) return;
    this.productDocumentInterface = [];
    let frmArray = this.getAgreeFormArray();
    frmArray.clear();
    this.motorDataDataService
      .getProductDocumentById(
        this.selectedQuotation.productId,
        this.translate.currentLang,
        this.personalInfo?.insuranceType
      )
      .pipe(shareReplay())
      .subscribe({
        next: (x) => {
          this.productDocumentInterface = x;
          x.forEach((doc) => {
            if (doc.neededUserAgree) {
              let frm = this.formBuilder.group({
                checked: new FormControl(false, [Validators.requiredTrue]),
                name: new FormControl(doc.name),
                url: new FormControl(doc.url)
              });
              frmArray.push(frm);
            }
          });
        },
        error: (err) => {}
      });
  }

  benefitDialog(item) {
    this.dialog.open(BenefitDialogComponent, {
      panelClass: "benefit-dialog",
      data: {
        productId: item.productId,
        code: item.code,
        lang: this.translate.currentLang,
        insuranceType: this.personalInfo.insuranceType
      }
    });
  }

  onNextClick(): void {
    const hasSelectedDrivePlus =
      this.selectedMotorMembership.some((item) => item.code === "DrivePlus") ||
      this.selectedMotorMembership.some(
        (item) => item.code === "DrivePlusLite"
      ) ||
      this.selectedMotorMembership.some(
        (item) => item.code === "DrivePlusStandard"
      ) ||
      this.selectedMotorMembership.some(
        (item) => item.code === "DrivePlusPremium"
      ) ||
      this.selectedMotorMembershipLockDeal.some(
        (item) => item.code === "DrivePlus"
      );
    if (hasSelectedDrivePlus) {
      this.stepper.next();
    } else {
      const membershipId = this.motorMembershipList.find(
        (x) => x.isDefault
      )?.id;
      this.dialog.open(ConfirmDriveplusDialogComponent, {
        data: {
          stepper: this.stepper,
          toggleAddOn: this.toggleMotorMembership.bind(this),
          addon: this.motorMembershipList.find((x) => x.isDefault),
          discountPercentage: this.motorMembershipBenefits.find(
            (x) =>
              x.code === "RoadTaxDiscount" &&
              x.motorMembershipId === membershipId
          ).discountPercentage
        },
        panelClass: "confirm-driveplus-dialog"
      });
    }
  }

  addDriver() {
    let frmArray = this.getDriversFormArray();
    let form = this.formBuilder.group({
      name: [null, Validators.required],
      idType: [this.idTypeList[0].codeValue, Validators.required],
      identityNo: [
        null,
        [Validators.required, ValidatorFunction.nricValidator()]
      ],
      dob: [null, Validators.required],
      gender: ["M", Validators.required],
      maritalStatus: ["Single", Validators.required],
      relationship: [null, Validators.required],
      isMalaysian: [true]
    });

    form.get("idType").valueChanges.subscribe((value) => {
      if (value === "IC_NO") {
        form
          .get("identityNo")
          .setValidators([
            Validators.required,
            ValidatorFunction.nricValidator()
          ]);
      } else {
        form.get("identityNo").setValidators(Validators.required);
      }

      if (["IC_NO", "POLICE/ARMY"].includes(value)) {
        form.get("isMalaysian").patchValue(true);
      } else {
        form.get("isMalaysian").patchValue(false);
      }

      form.get("identityNo").reset();
      form.get("identityNo").updateValueAndValidity();
    });

    form.get("identityNo").valueChanges.subscribe((value) => {
      if (
        form.get("identityNo").invalid &&
        form.get("idType").value === "IC_NO"
      ) {
        form.get("dob").reset();
      }

      if (
        form.get("identityNo").valid &&
        form.get("idType").value === "IC_NO"
      ) {
        let date = moment(value.substring(0, 6), "YYMMDD");
        let lastChar = value.substring(11);
        let gender = lastChar % 2 ? "M" : "F";

        if (moment().isBefore(date)) {
          date.subtract(100, "year");
        }
        form.patchValue({
          dob: date.toDate(),
          gender: gender
        });
      }
    });

    frmArray.push(form);
  }

  deleteDriver(i: number) {
    let frmArray = this.getDriversFormArray();
    frmArray.removeAt(i);
  }

  driverRadioChange(e: ProductAddOnInterface, isCheckbox: boolean = false) {
    let index = this.selectedAddOn.findIndex((x) => x.category == e.category);
    if (index >= 0) this.selectedAddOn.splice(index, 1);
    if (!isCheckbox || index == -1) {
      this.selectedAddOn.push(e);

      this.pushCleverTapSelectAddOn(e.code);
    }

    let indexDisplay = this.selectedAddOnToDisplay.findIndex(
      (x) => x.category == e.category
    );
    if (indexDisplay >= 0) this.selectedAddOnToDisplay.splice(indexDisplay, 1);
    if (!isCheckbox || indexDisplay == -1) {
      this.selectedAddOnToDisplay.push(e);
    }

    let frmArray = this.getDriversFormArray();
    frmArray.reset();
    frmArray.clear();

    if (frmArray.length === 0 && e.code == "AdditionalDrivers")
      this.addDriver();
  }

  getDrivePlusRoadtaxPrice() {
    let isSelectedLockedDeal =
      this.hasSelectedMotorMembershipLockDealCategory("DrivePlus");
    const membershipId = this.motorMembershipList.find(
      (x) => x.code === this.selectedMotorMembershipString
    )?.id;
    const evaluate = isSelectedLockedDeal
      ? this.motorMembershipBenefitsLockDeal.find(
          (x) =>
            x.code === "RoadTaxDiscount" && x.motorMembershipId === membershipId
        )?.evaluate
      : this.motorMembershipBenefits.find(
          (x) =>
            x.code === "RoadTaxDiscount" && x.motorMembershipId === membershipId
        )?.evaluate;

    return eval(evaluate);
  }

  getRoadtaxDisplayPrice() {
    if (this.showRoadTaxList) {
      // if roadtax is selected
      if (
        !this.addOnFormGroup.controls.roadTaxPrice.value ||
        this.isIncludeDigitalRoadtax
      ) {
        // set default roadtax price as roadtaxprice from api
        this.addOnFormGroup.controls.roadTaxPrice.setValue(
          this.personalInfo.originalRoadTaxPrice
        );
      }
      // if its delivery roadtax price, use form value to get the added delivery price
      return this.addOnFormGroup.controls["roadTaxPrice"].value;
    } else {
      return this.personalInfo?.originalRoadTaxPrice;
    }
  }

  radioDigitalRoadTaxChange(e: any, isChecked: boolean = false) {
    if (e.value == "digitalRoadTax") {
      this.isIncludeDigitalRoadtax = true;
      this.addOnFormGroup.controls.roadTaxPrice.setValue(
        this.personalInfo.originalRoadTaxPrice
      );
    } else {
      let roadtaxHandlingFee = this.hasSelectedMotorMembershipCode(
        this.selectedMotorMembershipString
      )
        ? this.membershipRTHandlingFee
        : 15;
      this.isIncludeDigitalRoadtax = false;
      this.addOnFormGroup.controls.roadTaxPrice.setValue(
        this.personalInfo.originalRoadTaxPrice + roadtaxHandlingFee
      );
    }

    this.getCampaignPrice();
  }

  getRule(e: ProductAddOnInterface) {
    if (e.rules) {
      return JSON.parse(e.rules);
    }
    return null;
  }

  getDriversFormArray() {
    return this.addOnFormGroup.get("drivers") as FormArray;
  }

  getAgreeFormArray() {
    return this.agreementFrmGroup.get("doc") as FormArray;
  }

  getFormArrayControlError(i, formControlName) {
    return (this.getDriversFormArray().controls[i] as FormGroup).controls[
      formControlName
    ].errors;
  }

  applyPromoCode() {
    if (!this.promoCode) return;
    this.ngxSpinnerService.show();
    this.promoError = null;
    this.motorDataDataService;
    this.motorDataDataService
      .applyPromoCode(
        this.id,
        this.promoCode,
        this.personalInfo.vehicleNo,
        this.personalInfo.identityNo,
        this.getTotalCharge()
      )
      .subscribe({
        next: (x) => {
          if (x.name !== "New User Reward Voucher") {
            this.promo = null;
            this.promo = x;
            this.ngxSpinnerService.hide();
            this.promoCheck();
            this.pushCleverTapPromoApplied();

            if (this.promo) {
              this.getEppRateList(this.promo.id);
            }
          } else {
            this.promoGamification = null;
            this.promoGamification = x;
            this.ngxSpinnerService.hide();
            this.promoGamificationCheck();
            this.pushCleverTapPromoGamificationApplied();
          }
        },
        error: (err) => {
          this.ngxSpinnerService.hide();
          this.promoError = err.error.message;

          if (err.error.message === "InsufficientPromoCodeMinAmount") {
            this.promoMinAmount = Number(err.error.parameters[0]);
          }

          if (err.error.message === "InsufficientPromoCodeMaxAmount") {
            this.promoMaxAmount = Number(err.error.parameters[0]);
          }

          if (!this.promoCode.includes("NEWUSER")) {
            this.promo = null;
          } else {
            this.promoGamification = null;
          }
        }
      });
  }

  private promoCheck() {
    if (!this.promo) return;
    if (
      this.promo.customCode == "RoadTaxDelivery" &&
      !this.addOnFormGroup.value.isIncludeRoadtax
    ) {
      this.promo = null;
      this.promoCode = null;
      this.promoError = "InvalidPromoCode";
    }
  }

  private promoGamificationCheck() {
    if (!this.promoGamification) return;
  }

  clearPromoCode() {
    if (this.promoCode != null) this.promoCode = null;
    if (this.promoGamification != null) this.promoGamification = null;
    this.promoError = null;
    this.promo = null;
    this.getEppRateList();
  }

  applyReferralCode() {
    if (!this.referralCode) return;

    this.ngxSpinnerService.show();
    this.referralError = null;

    this.motorDataDataService
      .applyReferralCode(
        this.id,
        this.referralCode,
        this.personalInfo.identityNo
      )
      .subscribe({
        next: (x) => {
          this.referral = null;
          this.referral = x;
          this.ngxSpinnerService.hide();
          this.referralCheck();
          this.pushCleverTapReferralApplied();
        },
        error: (err) => {
          this.ngxSpinnerService.hide();
          this.referralError = err.error.message;
          this.referral = null;
        }
      });
  }

  private referralCheck() {
    if (!this.referral) return;
  }

  clearReferralCode() {
    if (this.referralCode != null) this.referralCode = null;
    this.referralError = null;
    this.referral = null;
  }

  paymentTypeChange(paymentType: string) {
    this.selectedPayment = paymentType;
  }

  submit() {
    this.pushCleverTapPaymentInitiated();
    this.ngxSpinnerService.show();

    const infoValue = this.infoFormGroup.value;

    // [PSSR-1508] Generali E2E Flow:
    //  - GET ORDER API should be exewcuted before payment due to validation on their end
    //  - if validation failed, the quotation should not be allowed to get purchased
    //  - else, customers paid for the quotation yet GET ORDER failed, and unable to proceed to issuance
    //  - and manual handling such quotations tend to have premiums discrepancies

    if (this.isGeneraliIQ) {
      this.isShowGeneraliPaymentConfirmation = false;

      const getOrderInfo: GeneraliGetOrderInfoInterface = {
        address1: infoValue.address1,
        address2: infoValue.address2,
        city: infoValue.city
      };

      this.motorDataDataService
        .processGeneraliOrder(this.quotationId, getOrderInfo)
        .subscribe({
          next: (x: any) => {
            this.ngxSpinnerService.hide();

            if (x.getOrderResult) {
              this.generateBundlePayment();
            } else {
              this.alertService.openSnackBar(
                "Failed to process order, please contact Policy Street."
              );
            }
          },
          error: () => {
            this.ngxSpinnerService.hide();
            this.alertService.openSnackBar(
              "Failed to process order, please contact Policy Street."
            );
          }
        });
    } else {
      this.generateBundlePayment();
    }
  }

  generateBundlePayment() {
    this.motorBundleService
      .generateBundlePayment(this.id, this.buildFormData())
      .subscribe({
        next: (x: any) => {
          if (x.redirectUrl) {
            window.location.href = x.redirectUrl;
          } else {
            let navigationExtras: NavigationExtras = {
              queryParams: {
                id: x.id,
                partnerCode: "ps"
              }
            };
            this.ngxSpinnerService.hide();
            this.router.navigate(["/payment"], navigationExtras);
          }
        },
        error: (err) => {
          this.alertService.openSnackBar(err.error);
          this.ngxSpinnerService.hide();
          if (
            err.error &&
            (err.error.includes(FULLY_REDEEMED_MSG) ||
              err.error.includes(HAS_ENDED_MSG))
          ) {
            setTimeout(() => {
              location.reload();
            }, 3000); // Delay of 3 seconds
          }
        }
      });
  }

  editQuotation() {
    let dialogRef = this.dialog.open(EditQuotationComponent, {
      data: {
        id: this.id,
        request: this.personalInfo,
        quotationList: this.quotationList,
        bundleSite: true
      },
      panelClass: "edit-quote-dialog"
    });

    dialogRef.afterClosed().subscribe((x) => {
      if (x) {
        this.dialog.open(SubmitSuccessDialogComponent, {
          data: {
            editQuotations: true
          },
          panelClass: "success-dialog"
        });
      }
    });
  }
  // Get price list
  getTotalBundlePrice() {
    let total = 0;
    this.selectedBundle.forEach((x) => {
      total += parseFloat(x.evaluate);
    });
    return total;
  }

  getTotalBundleAddonPrice() {
    let total = 0;
    this.selectedBundleAddOn.forEach((x) => {
      total += parseFloat(x.evaluate);
    });
    return total;
  }

  getTotalAddOnPrice() {
    let total = 0;

    this.includedAddOn.forEach((x) => {
      total += this.getPrice(x);
    });

    const filteredAddOns = this.selectedAddOn.filter(
      (x) => x.category !== "PSXTRA" && x.isIncludeSST
    );

    filteredAddOns.forEach((x) => {
      if (x.code == "AdditionalDrivers")
        total += this.getPrice(x, this.getDriversFormArray().length);
      else if (x.code === "UnlimitedDrivers")
        total += this.getPrice(x, x.evaluate);
      else if (x.category == "Windshield")
        total += this.getPrice(x, this.addOnFormGroup.value.windshield);
      else if (x.category == "LLTP")
        total += this.getPrice(x, this.numberOfLltpSeats);
      else if (x.category == "GCKT")
        total += this.getPrice(x, this.addOnFormGroup.value.gckt);
      else if (x.category == "VA")
        total += this.getPrice(x, this.addOnFormGroup.value.va);
      else total += this.getPrice(x);
    });
    return total;
  }

  getTotalMotorMembershipPrice() {
    let total = 0;

    /* Locked Deal Membership */
    this.selectedMotorMembershipLockDeal.forEach((x) => {
      total += this.getPrice(x);
    });

    /* Latest Membership */
    this.selectedMotorMembership.forEach((x) => {
      total += this.getPrice(x);
    });

    return total;
  }

  getTotalPsxtraAddOnPrice() {
    let total = 0;
    const filteredAddOns = this.selectedAddOn.filter(
      (x) => x.category === "PSXTRA"
    );
    filteredAddOns.forEach((x) => {
      total += this.getPrice(x);
    });
    return total;
  }

  getTotalNonSSTAddOnPrice() {
    let total = 0;
    const filteredAddOns = this.selectedAddOn.filter(
      (x) => x.category !== "PSXTRA" && !x.isIncludeSST
    );
    filteredAddOns.forEach((x) => {
      if (x.customCode === "UnlimitedTowing_PA") {
        total += this.getPrice(x, this.numberOfLltpSeats);
      } else {
        total += this.getPrice(x);
      }
    });
    return total;
  }

  getNcdPrice() {
    if (this.isTMIMIQ) {
      return this.selectedQuotation.ncd;
    } else if (this.selectedExcess) {
      return (
        (this.selectedQuotation?.basePremium - this.selectedExcess?.price) *
        this.personalInfo?.ncd
      );
    } else {
      return this.selectedQuotation?.basePremium * this.personalInfo?.ncd;
    }
  }

  getTotalBasePremium() {
    if (this.selectedExcess) {
      // Any selected Excess will recalculate Total Base Premium
      return (
        this.selectedQuotation?.basePremium -
        this.getNcdPrice() -
        this.selectedExcess?.price
      );
    } else {
      // If Excess is disabled, Total Base Premium will be the one returned from BE
      return this.selectedQuotation?.totalBasePremium;
    }
  }

  getTotalGrossPremium() {
    if (!this.personalInfo && !this.selectedQuotation) return 0;

    return (
      this.getTotalBasePremium() +
      this.getTotalAddOnPrice() +
      this.getTotalBundlePrice() +
      this.getTotalBundleAddonPrice()
    );
  }

  getServiceTax() {
    if (!this.selectedQuotation) return 0;
    let total = this.getTotalGrossPremium();
    return total * this.selectedQuotation.taxRate;
  }

  getTotalNetPremium() {
    var total =
      Number(this.getTotalGrossPremium().toFixed(2)) +
      Number(this.getServiceTax().toFixed(2)) +
      this.selectedQuotation?.stampDutyPrice;
    total =
      this.selectedQuotation &&
      this.selectedQuotation.code.toLowerCase() === "takaful_malaysia"
        ? CommonFunction.customSTMBRound(total)
        : total;

    return total;
  }

  getPlatformDiscountRate() {
    return (
      this.selectedQuotation?.platformDiscountRate * this.getTotalGrossPremium()
    );
  }

  getTotalPromo() {
    if (!this.promo) return 0;

    let evaluate = this.promo.evaluate;
    evaluate = evaluate.replace(
      "{TotalGrossPremium}",
      this.getTotalGrossPremium().toString()
    );
    return Number.parseFloat(eval(evaluate));
  }

  getTotalPromoGamification() {
    if (!this.promoGamification) return 0;

    let evaluate = this.promoGamification.evaluate;
    evaluate = evaluate.replace(
      "{TotalGrossPremium}",
      this.getTotalGrossPremium().toString()
    );
    return Number.parseFloat(eval(evaluate));
  }

  getTotalCharge() {
    let total = this.getTotalNetPremium() - this.getPlatformDiscountRate();
    if (this.addOnFormGroup.value?.isIncludeRoadtax) {
      let hasSelectedDrivePlus =
        this.selectedMotorMembership.some(
          (item) => item.code === this.selectedMotorMembershipString
        ) ||
        this.selectedMotorMembershipLockDeal.some(
          (item) => item.code === "DrivePlus"
        );
      let roadtaxRenewalPrice =
        hasSelectedDrivePlus && this.updateOriginalRoadtaxPrice != 0
          ? this.getDrivePlusRoadtaxPrice()
          : this.updateOriginalRoadtaxPrice;
      let roadtaxHandlingFee = hasSelectedDrivePlus
        ? this.membershipRTHandlingFee
        : this.personalInfo.roadTaxDeliveryPrice;

      total = total + roadtaxRenewalPrice;

      // If digital road tax is not selected, add delivery price
      if (!this.isIncludeDigitalRoadtax) {
        total = total + roadtaxHandlingFee;
      }
    }

    total =
      total +
      this.getTotalPsxtraAddOnPrice() +
      this.getTotalNonSSTAddOnPrice() +
      this.getTotalMotorMembershipPrice() -
      this.getAtomeDiscount() -
      this.getEppDiscount();

    if (this.selectedQuotation?.rebate !== null)
      total = total - this.selectedQuotation?.rebate;
    else total;

    return total;
  }

  getServiceFee() {
    if (!this.selectedQuotation) return 0;

    //Requested by Siew Wai to increase the Service Fee rate by 0.2% if Digital Road Tax is selected. (Removed for now)
    //const digiRoadTaxServiceFeeRateIncrease = 0.002;

    // let serviceFeeDigital =
    // 	(this.selectedQuotation.serviceTaxRate +
    // 		digiRoadTaxServiceFeeRateIncrease) *
    // 	(this.getTotalCharge() - this.getTotalPromo());

    // [MTR-722] For D2C:
    // - Generali/TMIM: 5.6% atome BNPL (no service fee)
    // - Others: 3.6% atome BNPL + 2% service fee
    const code = this.selectedQuotation.code;
    this.selectedQuotation.serviceTaxRate =
      code === "TMIM" ||
      code === "AXA" ||
      code === "Zurich" ||
      code === "Zurich_Takaful"
        ? 0
        : this.selectedQuotation.serviceTaxRate;

    let serviceFee =
      this.selectedQuotation.serviceTaxRate *
      (this.getTotalCharge() -
        (this.getTotalPromo() + this.getTotalPromoGamification()) -
        this.memberRenewalDiscountPrice);

    if (serviceFee < 0) serviceFee = 0;
    //if (this.isIncludeDigitalRoadtax)
    //return Number(serviceFeeDigital.toFixed(2));
    //else
    return Number(serviceFee.toFixed(2));
  }

  getPremium() {
    // Total without serviceFee
    let totalBeforeCharges =
      this.getTotalCharge() -
      (this.getTotalPromo() + this.getTotalPromoGamification()) -
      this.memberRenewalDiscountPrice;
    if (totalBeforeCharges < 0) totalBeforeCharges = 0;
    return totalBeforeCharges;
  }

  getBankInstalmentCharges() {
    if (
      this.hasSelectedMotorMembershipCode(this.selectedMotorMembershipString)
    ) {
      return this.membershipEppRate != null
        ? this.getPremium() * this.membershipEppRate
        : this.getPremium() * this.getEppRate();
    } else {
      return this.getPremium() * this.getEppRate();
    }
  }

  getBNPLCharges() {
    // return the BNPL Service Tax Rate
    //  - Total Service Tax Rate - Portal Service Tax Rate = BNPL Service Tax Rate
    let paymentProvider = this.paymentFormGroup?.value?.paymentProvider;
    const bnplRate = this.bnplRateList?.filter(
      (entry) => entry.paymentMethod == paymentProvider
    );
    if (bnplRate.length > 0) {
      let bnplServiceTaxRate =
        (bnplRate[0].isSubsidized && !this.promo) ||
        (bnplRate[0].isSubsidized && this.promo && bnplRate[0].isAllowPromoCode)
          ? 0
          : bnplRate[0].totalServiceTaxRate -
            this.selectedQuotation.serviceTaxRate;
      let bnplServiceFee =
        bnplServiceTaxRate *
        (this.getTotalCharge() -
          (this.getTotalPromo() + this.getTotalPromoGamification()) -
          this.memberRenewalDiscountPrice);
      if (bnplServiceFee < 0) bnplServiceFee = 0;
      return Number(bnplServiceFee.toFixed(2));
    } else {
      return 0;
    }
  }

  getFinalTotalBeforeCharges() {
    // Total with serviceFee, without instalmentCharges
    let total =
      this.getTotalCharge() -
      (this.getTotalPromo() + this.getTotalPromoGamification()) +
      this.getServiceFee() +
      this.getBNPLCharges() -
      this.memberRenewalDiscountPrice;

    return Math.max(total, 0);
  }

  getFinalTotal() {
    let totalBeforeCharges =
      this.getTotalCharge() -
      (this.getTotalPromo() + this.getTotalPromoGamification()) +
      this.getServiceFee() +
      this.getBNPLCharges() -
      this.memberRenewalDiscountPrice;

    if (totalBeforeCharges < 0) totalBeforeCharges = 0;

    if (this.isPaymentTypeEPP) {
      return Math.max(totalBeforeCharges + this.getBankInstalmentCharges(), 0);
    } else {
      // If not EPP
      return Math.max(totalBeforeCharges, 0);
    }
  }
  // End Get price list

  getPaymentDurationLabel() {
    let paymentFGroup = this.paymentFormGroup?.value;
    if (paymentFGroup?.paymentType == this.paymentOptionEPP) {
      if (paymentFGroup?.installmentMonth == 3) {
        return `<span class='bold'>RM ${this._decimalPipe.transform(
          this.getFinalTotal() / 3,
          "1.2-2"
        )}</span>
				${this.translate.instant("common.perMonth")}
				${this.translate.instant("paymentOptions.for3months")}`;
      } else if (paymentFGroup?.installmentMonth == 6) {
        return `<span class='bold'>RM ${this._decimalPipe.transform(
          this.getFinalTotal() / 6,
          "1.2-2"
        )}</span>
				${this.translate.instant("common.perMonth")}
				${this.translate.instant("paymentOptions.for6months")}`;
      } else if (paymentFGroup?.installmentMonth == 12) {
        return `<span class='bold'>RM ${this._decimalPipe.transform(
          this.getFinalTotal() / 12,
          "1.2-2"
        )}</span>
				${this.translate.instant("common.perMonth")}
				${this.translate.instant("paymentOptions.for12months")}`;
      }
    }

    return "";
  }

  getPSComissionPrice() {
    // PS comission, only shown in Allianz quote in order summary section
    let comission = this.getTotalGrossPremium() * (10 / 100);
    return Number(comission.toFixed(2));
  }

  openCarVariantDialog(id: string) {
    let dialogRef = this.dialog.open(CarVariantDialogComponent, {
      panelClass: "edit-car-variant-dialog",
      data: { requestData: this.personalInfo, linkId: this.id },
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result && result.data === true) {
        this.selectQuotation(id);
      }
    });
  }

  getBundleBrochure(itemCode: string) {
    let lang = this.translate.currentLang;
    let basePath = "https://storage.googleapis.com/ps-asset/motor/FFF/Bundle/";
    let basePath2 = "_Brochure_";
    let fileFormat = ".pdf";

    return basePath + itemCode + basePath2 + lang + fileFormat;
  }

  // -- CleverTap Analytics Functions
  pushCleverTapPageView(pageIndex: number) {
    this.cleverTapService.pageViewed(pageIndex);
  }

  pushCleverTapSelectedInsurer() {
    this.cleverTapService.insurerSelected(this.selectedQuotation.code);
  }

  pushCleverTapSelectAddOn(addOnCode: string) {
    this.cleverTapService.addOnSelected(addOnCode);
  }

  pushCleverTapSelectMotorMembership(addOnCode: string) {
    this.cleverTapService.motorMembershipSelected(addOnCode);
  }

  pushCleverTapPersonalDetails() {
    this.cleverTapService.personalDetailsFilled(this.infoFormGroup.value.city, this.infoFormGroup.value.state);
  }

  pushCleverTapExcessSelection() {
    this.cleverTapService.excessFeeSelected(this.selectedExcess.name);
  }

  pushCleverTapPromoApplied() {
    this.cleverTapService.promoCodeApplied(this.promoCode);
  }

  pushCleverTapPromoGamificationApplied() {
    this.cleverTapService.promoCodeApplied(this.promoGamification);
  }

  pushCleverTapReferralApplied() {
    this.cleverTapService.referralCodeApplied(this.referralCode);
  }

  pushCleverTapPaymentOptionSelected() {
    this.cleverTapService.paymentOptionSelected(
      this.paymentFormGroup.value.paymentType,
      this.paymentFormGroup.value.bank,
      this.paymentFormGroup.value.installmentMonth
    );
  }

  pushCleverTapPaymentInitiated() {
    this.cleverTapService.paymentInitiated();
  }
  // -- CleverTap Analytics Functions

  // -- Other insurer section
  updateSelectedInsurers(id: string) {
    const index = this.selectedOtherInsurers.indexOf(id);
    if (index === -1) {
      this.selectedOtherInsurers.push(id);
    } else {
      this.selectedOtherInsurers.splice(index, 1);
    }
  }

  submitOtherInsurer() {
    let typeOfSum = this.personalInfo.typeOfSum ?? "MV";

    this.motorQuotationService
      .submitExtraProduct(this.id, typeOfSum, this.selectedOtherInsurers)
      .subscribe({
        next: (x) => {
          this.handleSuccessSubmitQuotation({
            preferredChannel: this.personalInfo.preferredChannel,
            email: this.personalInfo.email,
            mobileNo: this.personalInfo.mobileNo
          });
        }
      });
  }
  // -- Other insurer section

  get sortedQuotationList() {
    return this.quotationList.sort((a, b) => {
      if (a.status === "Rejected" && b.status !== "Rejected") {
        return -1;
      }
      if (a.status !== "Rejected" && b.status === "Rejected") {
        return 1;
      }
      return 0;
    });
  }

  get disableEditQuotationBtn() {
    const availableCount = this.quotationList.filter(
      (x) => x.status == "Available"
    ).length;
    return availableCount == 0;
  }

  private handleSuccessSubmitQuotation(
    customerInput: Partial<MotorQuotationInterface>
  ): void {
    const dialogRef = this.dialog.open(SubmitSuccessDialogComponent, {
      panelClass: "success-dialog",
      data: { customerInput }
    });

    dialogRef.afterClosed().subscribe(() => location.reload());
  }

  getMinMaxWindscreenPrice(
    addOn: ProductAddOnInterface,
    key: "min" | "max"
  ): number {
    const rule = this.getRule(addOn);
    const { maxWindshieldPrice, minWindshieldPrice } = this.selectedQuotation;

    const config = {
      max: maxWindshieldPrice || rule?.max || 10000,
      min: minWindshieldPrice || rule?.min || 500
    };

    return config[key];
  }

  toUpperCase(event: any, controlName: string): void {
    const inputValue = event.target.value.toUpperCase();
    this.infoFormGroup
      .get(controlName)
      ?.setValue(inputValue, { emitEvent: false });
  }

  checkIsGeneraliCompanyQuotation() {
    return (
      this.idType === this.idTypeOption.company &&
      this.selectedQuotation?.code === "AXA"
    );
  }

  showGeneraliPaymentConfirmation() {
    this.isShowGeneraliPaymentConfirmation = true;
  }

  hideGeneraliPaymentConfirmation() {
    this.isShowGeneraliPaymentConfirmation = false;
  }

  showAcknowledgementDialog() {
    const dialogRef = this.dialog.open(AcknowledgementComponent, {
      width: "450px",
      maxWidth: "560px",
      panelClass: "centered-dialog",
      disableClose: true,
      data: {
        selectedQuotation: this.selectedQuotation,
        productDocument: this.productDocumentInterface
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.isSubmit) {
        this.isDirectMarketing = result.isDirectMarketing;
        this.submit();
      }
    });
  }

  private getCARTAddOnPriceList() {
    this.motorDataDataService.getCARTAddOnPriceList().subscribe({
      next: (x: MotorAddOnCARTPriceInterface[]) => {
        this.cartAddOnPriceList = x;
      }
    });
  }

  openPIDMLink(lang: string) {
    let link;
    if (lang == "en") {
      link = "https://www.pidm.gov.my/en";
    } else if (lang == "bm") {
      link = "https://www.pidm.gov.my/my";
    }
    window.open(link, "_blank");
  }
  openBrochureLink(lang: string) {
    let link;
    if (lang == "en") {
      link =
        "https://www.pidm.gov.my/pidm2022/media/downloads/Takaful-And-Insurance-Benefits-Protection-System-Brochure.pdf";
    } else if (lang == "bm") {
      link =
        "https://www.pidm.gov.my/pidm2022/media/downloads/Sistem-Perlindungan-Manfaat-Takaful-Dan-Insurans-Risalah.pdf";
    }
    window.open(link, "_blank");
  }

  getMotorMembershipClass(addOn: MembershipAddonInterface): string {
    if (addOn?.productCode === "TMIM") return "motorMembershipTMIM";
    else if (addOn?.isForExistingCust === true) return "motorMembershipLoyalty";

    return "motorMembership";
  }

  // Upload Photo
  uploadFile(e: any, name: string = "") {
    let files = e.target.files;

    if (files.length) {
      for (let i = 0; i < files.length; i++) {
        let file: File = e.target.files[i];

        // Validate file format
        if (!FileFunction.isImageOrPdf(file)) {
          this.alertService.openSnackBar(
            this.translate.instant("plans.step3Content.fileFormatErrorMsg", {
              fileName: file.name,
              fileExtension: this.vehiclePhotoValidation.fileExtensionToDisplay
            })
          );
          return;
        }

        // Validate file size
        if (!FileFunction.isValidFileSize(file, 5)) {
          this.alertService.openSnackBar(
            this.translate.instant("plans.step3Content.fileSizeErrorMsg", {
              fileName: file.name,
              fileSize: this.vehiclePhotoValidation.fileSize
            })
          );
          return;
        }

        this.uploadVehiclePhoto.find((x) => x.name == name).selectedFile = file;
      }
    }
  }

  deleteFile(name: string = "") {
    this.uploadVehiclePhoto.find((x) => x.name == name).selectedFile = null;
  }

  toggleVehiclePhoto(e: MatCheckboxChange) {
    this.showUploadMenu = e.checked;
  }

  getInsuranceOrTakafulWording(tolower: boolean) {
    let str = "";

    if (this.isTakaful) str = this.translate.instant("common.takaful");
    else str = this.translate.instant("common.insurance");

    if (tolower) str = str.toLowerCase();

    return str;
  }

  private buildFormData() {
    const infoValue = this.infoFormGroup.value;
    const addOnValue = this.addOnFormGroup.value;

    const bundleIdList = this.selectedBundle.map((x) => x.id);
    const bundleAddOnIdList = this.selectedBundleAddOn.map((x) => x.id);
    const addOnIdList = [...this.selectedAddOn, ...this.includedAddOn].map(
      (x) => x.id
    );
    const motorMembershipIdList = this.selectedMotorMembership.map((x) => x.id);
    const motorMembershipIdLockDeal = this.selectedMotorMembershipLockDeal.map(
      (x) => x.id
    );

    let paymentFGroup = this.paymentFormGroup?.value;

    if (paymentFGroup) {
      if (paymentFGroup.paymentChannel === this.paymentOptionEwallet)
        // To change payment channel for e-wallet and EPP
        paymentFGroup.paymentChannel = paymentFGroup.ewalletType;
      else if (paymentFGroup.paymentType === this.paymentOptionEPP)
        paymentFGroup.paymentChannel = paymentFGroup.bank;
      else if (paymentFGroup.paymentChannel === this.paymentOptionFpxEnterprise)
        paymentFGroup.paymentChannel = paymentFGroup.fpxEnterpriseType;

      if (paymentFGroup.paymentProvider === this.paymentOptionShopback)
        // To change payment type null for shopback
        paymentFGroup.paymentType = null;
    }

    let formData = new FormData();
    formData.append("quotationId", this.quotationId);

    if (addOnValue.windshield != null)
      formData.append("windShield", addOnValue.windshield);

    if (addOnValue.drivers != null) {
      addOnValue.drivers.map((x: any, i: number) => {
        formData.append(
          `AdditionalDriverList[${i}].Dob`,
          x.dob instanceof Date ? x.dob.toISOString() : x.dob
        );
        formData.append(`AdditionalDriverList[${i}].Gender`, x.gender);
        formData.append(`AdditionalDriverList[${i}].IdType`, x.idType);
        formData.append(`AdditionalDriverList[${i}].IdentityNo`, x.identityNo);
        formData.append(
          `AdditionalDriverList[${i}].MaritalStatus`,
          x.maritalStatus
        );
        formData.append(`AdditionalDriverList[${i}].Name`, x.name);
        formData.append(
          `AdditionalDriverList[${i}].Relationship`,
          x.relationship
        );
        formData.append(
          `AdditionalDriverList[${i}].IsMalaysian`,
          x.isMalaysian
        );
      });
    }

    if (bundleIdList.length) {
      bundleIdList.map((x, i) => {
        formData.append(`motorBundleIds[${i}]`, x);
      });
    }

    if (bundleAddOnIdList.length) {
      bundleAddOnIdList.map((x, i) => {
        formData.append(`motorBundleAddOnIds[${i}]`, x);
      });
    }

    if (addOnIdList.length) {
      addOnIdList.map((x, i) => {
        formData.append(`addOnIds[${i}]`, x);
      });
    }

    if (this.promo != null) formData.append("promoCodeId", this.promo.id);

    if (this.promoGamification != null)
      formData.append("promoGamificationId", this.promoGamification.id);

    if (this.referral != null)
      formData.append("referralCodeId", this.referral.id);

    formData.append("occupation", null);
    formData.append("address", infoValue.address1);
    formData.append("address2", infoValue.address2);
    formData.append("city", infoValue.city);
    formData.append("state", infoValue.state);
    formData.append(
      "deliveryAddress",
      infoValue.deliveryAddress1 || infoValue.address1
    );
    formData.append(
      "deliveryAddress2",
      infoValue.deliveryAddress2 || infoValue.address2
    );
    formData.append("deliveryCity", infoValue.deliveryCity || infoValue.city);
    formData.append(
      "deliveryPostcode",
      infoValue.deliveryPostcode || this.personalInfo?.postcode
    );
    formData.append(
      "deliveryState",
      infoValue.deliveryState || infoValue.state
    );
    formData.append("includeRoadTax", this.showRoadTaxList.toString());
    formData.append(
      "includeDigitalRoadTax",
      this.isIncludeDigitalRoadtax.toString()
    );
    formData.append("name", this.infoFormGroup.get("name").value);
    formData.append("email", this.infoFormGroup.get("email").value);
    formData.append("mobileNo", this.infoFormGroup.get("mobileNo").value);
    formData.append("TIN", infoValue.TIN);
    formData.append("SSTRegNo", infoValue.SSTRegNo);
    formData.append(
      "paymentProvider",
      this.paymentFormGroup?.value?.paymentProvider || this.paymentOptionRazer
    );
    formData.append(
      "paymentType",
      paymentFGroup.paymentType || this.paymentOptionFullPrice
    );
    formData.append(
      "paymentChannel",
      paymentFGroup.paymentChannel || this.paymentOptionVisa
    );

    if (addOnValue.lltpSeats != null)
      formData.append("seat", addOnValue.lltpSeats);

    if (this.selectedExcess != null)
      formData.append("motorExcessId", this.selectedExcess.id);

    if (
      this.paymentFormGroup.value.installmentMonth != null &&
      this.paymentFormGroup.value.installmentMonth != ""
    )
      formData.append(
        "installmentMonth",
        this.paymentFormGroup.value.installmentMonth
      );

    if (this.availableSalesCampaign != null) {
      this.availableSalesCampaign.forEach((x: any, i: number) => {
        formData.append(`salesCampaignList[${i}].keyId`, x.keyId);
        formData.append(`salesCampaignList[${i}].id`, x.id);
        formData.append(`salesCampaignList[${i}].description`, x.description);
        formData.append(`salesCampaignList[${i}].dealBundleId`, x.dealBundleId);
        formData.append(
          `salesCampaignList[${i}].isMemberMandatory`,
          x.isMemberMandatory
        );
        formData.append(`salesCampaignList[${i}].dealType`, x.dealType);
        formData.append(`salesCampaignList[${i}].evaluate`, x.evaluate);
        formData.append(`salesCampaignList[${i}].isLockable`, x.isLockable);
        formData.append(`salesCampaignList[${i}].isFlashSales`, x.isFlashSales);
        formData.append(`salesCampaignList[${i}].isLockedDeal`, x.isLockedDeal);

        if (x.memberType != null) {
          formData.append(`salesCampaignList[${i}].memberType`, x.memberType);
        }

        if (x.evaluateType != null) {
          formData.append(
            `salesCampaignList[${i}].evaluateType`,
            x.evaluateType
          );
        }

        if (x.capAmount != null) {
          formData.append(`salesCampaignList[${i}].capAmount`, x.capAmount);
        }
      });
    }

    if (motorMembershipIdList.length) {
      motorMembershipIdList.map((x, i) => {
        formData.append(`motorMembershipIds[${i}]`, x);
      });
    }

    if (this.memberRenewalDiscountRefId != null)
      formData.append(
        "membershipDiscountRefId",
        this.memberRenewalDiscountRefId
      );

    formData.append("isDirectMarketing", this.isDirectMarketing.toString());

    if (addOnValue.cartDays != null)
      formData.append("cartDays", addOnValue.cartDays);

    if (addOnValue.cartDailyCoverage != null)
      formData.append("cartDailyCoverage", addOnValue.cartDailyCoverage);

    if (addOnValue.gckt != null) formData.append("gckt", addOnValue.gckt);

    if (addOnValue.va != null) formData.append("va", addOnValue.va);

    if (motorMembershipIdLockDeal.length) {
      motorMembershipIdLockDeal.map((x, i) => {
        formData.append(`lockDealMembershipIds[${i}]`, x);
      });
    }

    this.uploadVehiclePhoto
      .filter((x) => x.selectedFile != null)
      .forEach((x, i) => {
        formData.append(`UploadedVehiclePhotos[${i}].type`, x.type);
        formData.append(`UploadedVehiclePhotos[${i}].File`, x.selectedFile);
      });

    return formData;
  }

  private setDisplayCodeForInsurers() {
    // Add display code for specific insurers
    this.addOnListToDisplay.forEach((x) => {
      if (
        this.selectedQuotation.code == "Zurich" ||
        this.selectedQuotation.code == "Zurich_Takaful"
      )
        x.displayCode = `${x.code}Zurich`;
      else x.displayCode = x.code;
    });
  }

  private getCampaignPrice() {
    /* Road Tax */
    if (this.hasRoadtaxAddon) {
      /* Get Campaign with Road Tax Discount */
      const roadTaxCampaign =
        this.availableSalesCampaign != null
          ? this.availableSalesCampaign.find(
              (x) => x.dealType === "ROAD_TAX" && x.isMemberMandatory === false
            )
          : null;

      /* Get Road Tax Price */
      if (
        roadTaxCampaign != null &&
        !this.hasSelectedMotorMembershipCode(
          this.selectedMotorMembershipString
        ) &&
        this.personalInfo?.originalRoadTaxPrice != null
      ) {
        let roadtaxHandlingFee = !this.showRoadTaxList
          ? 0
          : this.isIncludeDigitalRoadtax
          ? 0
          : 15;

        if (roadTaxCampaign.evaluateType === "AMOUNT") {
          let evaluate =
            this.personalInfo?.originalRoadTaxPrice - roadTaxCampaign.evaluate;
          evaluate = evaluate < 0 ? 0 : evaluate;
          this.roadTaxPromoPrice = evaluate + roadtaxHandlingFee;
        } else {
          let evaluate = roadTaxCampaign.evaluate;
          evaluate = evaluate.replace(
            "{RoadTaxPrice}",
            this.personalInfo?.originalRoadTaxPrice.toString()
          );
          let discountAmt = eval(evaluate);
          this.roadTaxPromoPrice =
            roadTaxCampaign.capAmount != null &&
            this.personalInfo?.originalRoadTaxPrice - discountAmt >=
              roadTaxCampaign.capAmount
              ? roadTaxCampaign.capAmount + roadtaxHandlingFee
              : this.personalInfo?.originalRoadTaxPrice -
                discountAmt +
                roadtaxHandlingFee;
        }
      } else {
        this.roadTaxPromoPrice = null;
      }
    }
  }
}
